import ur, { createElement as hr } from "react";
const dr = "1.0.0-rc.4", ut = typeof window < "u", Qt = typeof global < "u" ? global : typeof window < "u" ? window : typeof self < "u" ? self : Function("return this")(), fr = () => !1, ee = Array.isArray, z = Object.assign, F = Object.defineProperty, ie = Object.defineProperties, pr = Object.prototype.toString, ue = Object.prototype.hasOwnProperty, te = (t) => pr.call(t);
function de(t) {
  return t === void 0;
}
function nt(t) {
  return t === null;
}
function I(t) {
  return typeof t == "string";
}
function Vt(t) {
  return typeof t == "boolean";
}
function rt(t) {
  return typeof t == "number";
}
function y(t) {
  return typeof t == "function";
}
function T(t) {
  return te(t) === "[object Object]";
}
function Xt(t) {
  return !nt(t) && typeof t == "object";
}
function ot(t) {
  return te(t) === "[object Promise]";
}
function mr(t) {
  return y(t) && t.name.indexOf("bound ") === 0 && !t.hasOwnProperty("prototype");
}
function ht(t) {
  var e;
  if (y(t)) {
    const n = t.toString();
    return ((e = t.prototype) === null || e === void 0 ? void 0 : e.constructor) === t && Object.getOwnPropertyNames(t.prototype).length > 1 || /^function\s+[A-Z]/.test(n) || /^class\s+/.test(n);
  }
  return !1;
}
function _r(t) {
  return typeof ShadowRoot < "u" && t instanceof ShadowRoot;
}
function Ue(t) {
  var e;
  return t instanceof URL || !!(!((e = t) === null || e === void 0) && e.href);
}
function ae(t) {
  var e;
  return t instanceof Element || I((e = t) === null || e === void 0 ? void 0 : e.tagName);
}
function ve(t) {
  var e;
  return t instanceof Node || rt((e = t) === null || e === void 0 ? void 0 : e.nodeType);
}
function Yt(t) {
  return te(t) === "[object HTMLLinkElement]";
}
function dt(t) {
  return te(t) === "[object HTMLStyleElement]";
}
function Ee(t) {
  return te(t) === "[object HTMLScriptElement]";
}
function Er(t) {
  return te(t) === "[object HTMLIFrameElement]";
}
function Ar(t) {
  return te(t) === "[object HTMLDivElement]";
}
function wr(t) {
  return te(t) === "[object HTMLImageElement]";
}
function vr(t) {
  return te(t) === "[object HTMLBaseElement]";
}
function it(t) {
  return ae(t) && t.tagName.toUpperCase() === "MICRO-APP-BODY";
}
function gr(t) {
  return te(t) === "[object ProxyDocument]";
}
function V(t, e, n) {
  if (t == null)
    throw new TypeError("includes target is null or undefined");
  const r = Object(t), o = parseInt(r.length, 10) || 0;
  if (o === 0)
    return !1;
  n = parseInt(n, 10) || 0;
  let i = Math.max(n >= 0 ? n : o + n, 0);
  for (; i < o; ) {
    if (e === r[i] || e !== e && r[i] !== r[i])
      return !0;
    i++;
  }
  return !1;
}
function O(t, e = null, ...n) {
  const r = e && I(e) ? ` app ${e}:` : "";
  I(t) ? console.error(`[micro-app]${r} ${t}`, ...n) : console.error(`[micro-app]${r}`, t, ...n);
}
function Y(t, e = null, ...n) {
  const r = e && I(e) ? ` app ${e}:` : "";
  I(t) ? console.warn(`[micro-app]${r} ${t}`, ...n) : console.warn(`[micro-app]${r}`, t, ...n);
}
function X(t, ...e) {
  Promise.resolve().then(t.bind(null, ...e));
}
const x = function() {
  class t extends URL {
  }
  return (e, n) => n ? new t("" + e, n) : new t("" + e);
}();
function ft(t) {
  return t.startsWith("//") ? `${Qt.location.protocol}${t}` : t;
}
function st(t, e = null) {
  if (!I(t) || !t)
    return "";
  try {
    const { origin: n, pathname: r, search: o } = x(ft(t), (window.rawWindow || window).location.href);
    if (/\.(\w+)$/.test(r))
      return `${n}${r}${o}`;
    const i = `${n}${r}/`.replace(/\/\/$/, "/");
    return /^https?:\/\//.test(i) ? `${i}${o}` : "";
  } catch (n) {
    return O(n, e), "";
  }
}
function W(t) {
  return !I(t) || !t ? "" : t.replace(/(^\d+)|([^\w\d-_])/gi, "");
}
function Xe(t) {
  const { origin: e, pathname: n } = x(t);
  if (/\.(\w+)$/.test(n)) {
    const o = `${e}${n}`.split("/");
    return o.pop(), o.join("/") + "/";
  }
  return `${e}${n}/`.replace(/\/\/$/, "/");
}
function G(t, e) {
  return !t || /^((((ht|f)tps?)|file):)?\/\//.test(t) || /^(data|blob):/.test(t) ? t : x(t, Xe(ft(e))).toString();
}
function Pr(t) {
  const e = t.split("/");
  return e.pop(), ft(e.join("/") + "/");
}
function Ye(t, e, n, r) {
  let o = 0;
  function i() {
    ++o === t.length && r && r();
  }
  t.forEach((s, a) => {
    ot(s) ? s.then((c) => {
      e({ data: c, index: a }), i();
    }).catch((c) => {
      n({ error: c, index: a }), i();
    }) : (e({ data: s, index: a }), i());
  });
}
function br() {
  return "noModule" in document.createElement("script");
}
function Rr() {
  return "inline-" + Math.random().toString(36).substr(2, 15);
}
function Sr(t) {
  return t.filter(function(e) {
    return e in this ? !1 : this[e] = !0;
  }, /* @__PURE__ */ Object.create(null));
}
const ze = Qt.requestIdleCallback || function(t) {
  const e = Date.now();
  return setTimeout(function() {
    t({
      didTimeout: !1,
      timeRemaining() {
        return Math.max(0, 50 - (Date.now() - e));
      }
    });
  }, 1);
};
function zt(t) {
  return new Promise((e) => {
    ze(() => {
      t(e);
    });
  });
}
let pt = null;
function at(t) {
  pt = t;
}
function j() {
  return pt;
}
let je = !1;
function B(t) {
  at(null), t && !je && (je = !0, X(() => {
    je = !1;
  }));
}
function fe(t) {
  pt !== t && !je && (at(t), X(() => {
    at(null);
  }));
}
function K(t, e) {
  const n = (window.rawDocument || document).createElement(t, e);
  return n.__MICRO_APP_NAME__ && delete n.__MICRO_APP_NAME__, n.__PURE_ELEMENT__ = !0, n;
}
function se(t) {
  return !t || /(^\d)|([^\w\d-_\u4e00-\u9fa5])/gi.test(t);
}
function Ae(t) {
  return /^body$/i.test(t) || /^head$/i.test(t) || /^html$/i.test(t) || /^title$/i.test(t) || /^:root$/i.test(t);
}
function re(t) {
  return _r(t) ? t.host : t;
}
function et(t) {
  return t ? t.replace(/^\s+|\s+$/g, "") : "";
}
function Ot() {
  return navigator.userAgent.indexOf("Firefox") > -1;
}
function Dt(t) {
  const e = {}, n = t.split("&");
  for (const r of n) {
    const o = r.indexOf("="), i = o < 0 ? r : r.slice(0, o), s = o < 0 ? null : r.slice(o + 1);
    if (i in e) {
      let a = e[i];
      ee(a) || (a = e[i] = [a]), a.push(s);
    } else
      e[i] = s;
  }
  return e;
}
function Ge(t) {
  let e = "";
  for (const n in t) {
    const r = t[n];
    nt(r) ? e += (e.length ? "&" : "") + n : (ee(r) ? r : [r]).forEach((i) => {
      de(i) || (e += (e.length ? "&" : "") + n, nt(i) || (e += "=" + i));
    });
  }
  return e;
}
function Ct() {
  const t = /* @__PURE__ */ new Set();
  function e(n) {
    return t.add(n), () => t.has(n) ? t.delete(n) : !1;
  }
  return {
    add: e,
    list: () => t
  };
}
function yr() {
  const t = /* @__PURE__ */ new Map();
  function e(n, r) {
    return t.set(n, r), () => t.has(n) ? t.delete(n) : !1;
  }
  return {
    add: e,
    get: (n) => t.get(n),
    delete: (n) => t.has(n) ? t.delete(n) : !1
  };
}
function ct(t) {
  const e = t.attributes, n = /* @__PURE__ */ new Map();
  for (let r = 0; r < e.length; r++)
    n.set(e[r].name, e[r].value);
  return n;
}
function De(t, e) {
  t ? t.push(() => zt((n) => {
    e(), n();
  })) : e();
}
function Ce(t) {
  return (t == null ? void 0 : t.reduce((e, n) => e.then(n), Promise.resolve())) || null;
}
function Le(t) {
  return t.startsWith("inline-");
}
function Lt(t, e, n, ...r) {
  try {
    y(t) && t(...r);
  } catch (o) {
    O(`An error occurred in app ${e} window.${n} 
`, null, o);
  }
}
function Mr(t) {
  for (; t != null && t.firstChild; )
    t.removeChild(t.firstChild);
}
function Or() {
  var t;
  return ((t = window.rawWindow) === null || t === void 0 ? void 0 : t.HTMLElement) || window.HTMLElement;
}
function Dr(t, e) {
  Object.defineProperties(t, {
    currentTarget: {
      get() {
        return e;
      }
    },
    target: {
      get() {
        return e;
      }
    }
  });
}
function oe(t, e, n, r) {
  var o;
  if (!t)
    return O(`element does not exist in lifecycle ${n}`, e);
  t = re(t), B();
  const i = z({
    name: e,
    container: t
  }, r && {
    error: r
  }), s = new CustomEvent(n, {
    detail: i
  });
  Dr(s, t), y((o = R.options.lifeCycles) === null || o === void 0 ? void 0 : o[n]) && R.options.lifeCycles[n](s), t.dispatchEvent(s);
}
function k(t, e, n = {}) {
  var r;
  const o = new CustomEvent(e, {
    detail: n
  });
  (r = t.sandBox) === null || r === void 0 || r.microAppWindow.dispatchEvent(o);
}
function pe(t, e = null, n = {}) {
  return B(), y(R.options.fetch) ? R.options.fetch(t, n, e) : window.fetch(t, n).then((r) => r.text());
}
class mt {
  static getInstance() {
    return this.instance || (this.instance = new mt()), this.instance;
  }
  /**
   * run logic of load and format html
   * @param successCb success callback
   * @param errorCb error callback, type: (err: Error, meetFetchErr: boolean) => void
   */
  run(e, n) {
    const r = e.name, o = e.ssrUrl || e.url;
    (o.includes(".js") ? Promise.resolve(`<micro-app-head><script src='${o}'><\/script></micro-app-head><micro-app-body></micro-app-body>`) : pe(o, r, { cache: "no-cache" })).then((s) => {
      if (!s) {
        const a = "html is empty, please check in detail";
        return e.onerror(new Error(a)), O(a, r);
      }
      s = this.formatHTML(o, s, r), n(s, e);
    }).catch((s) => {
      O(`Failed to fetch data from ${e.url}, micro-app stop rendering`, r, s), e.onLoadError(s);
    });
  }
  formatHTML(e, n, r) {
    return this.processHtml(e, n, r, R.options.plugins).replace(/<head[^>]*>[\s\S]*?<\/head>/i, (o) => o.replace(/<head/i, "<micro-app-head").replace(/<\/head>/i, "</micro-app-head>")).replace(/<body[^>]*>[\s\S]*?<\/body>/i, (o) => o.replace(/<body/i, "<micro-app-body").replace(/<\/body>/i, "</micro-app-body>"));
  }
  processHtml(e, n, r, o) {
    var i;
    if (!o)
      return n;
    const s = [];
    return o.global && s.push(...o.global), !((i = o.modules) === null || i === void 0) && i[r] && s.push(...o.modules[r]), s.length > 0 ? s.reduce((a, c) => T(c) && y(c.processHtml) ? c.processHtml(a, e) : a, n) : n;
  }
}
const Cr = /(^|\s+)(html|:root)(?=[\s>~[.#:]+|$)/, It = /(^|\s+)((html[\s>~]+body)|body)(?=[\s>~[.#:]+|$)/;
function Z(t, e) {
  t = e ? `${e} ${t}` : t;
  const n = new Error(t);
  throw n.reason = t, e && (n.filename = e), n;
}
class Lr {
  constructor() {
    this.cssText = "", this.prefix = "", this.baseURI = "", this.linkPath = "", this.result = "", this.scopecssDisable = !1, this.scopecssDisableSelectors = [], this.scopecssDisableNextLine = !1, this.mediaRule = this.createMatcherForRuleWithChildRule(/^@media *([^{]+)/, "@media"), this.supportsRule = this.createMatcherForRuleWithChildRule(/^@supports *([^{]+)/, "@supports"), this.documentRule = this.createMatcherForRuleWithChildRule(/^@([-\w]+)?document *([^{]+)/, "@document"), this.hostRule = this.createMatcherForRuleWithChildRule(/^@host\s*/, "@host"), this.importRule = this.createMatcherForNoneBraceAtRule("import"), this.charsetRule = this.createMatcherForNoneBraceAtRule("charset"), this.namespaceRule = this.createMatcherForNoneBraceAtRule("namespace"), this.containerRule = this.createMatcherForRuleWithChildRule(/^@container *([^{]+)/, "@container");
  }
  exec(e, n, r, o) {
    return this.cssText = e, this.prefix = n, this.baseURI = r, this.linkPath = o || "", this.matchRules(), Ot() ? decodeURIComponent(this.result) : this.result;
  }
  reset() {
    this.cssText = this.prefix = this.baseURI = this.linkPath = this.result = "", this.scopecssDisable = this.scopecssDisableNextLine = !1, this.scopecssDisableSelectors = [];
  }
  // core action for match rules
  matchRules() {
    for (this.matchLeadingSpaces(), this.matchComments(); this.cssText.length && this.cssText.charAt(0) !== "}" && (this.matchAtRule() || this.matchStyleRule()); )
      this.matchComments();
  }
  // https://developer.mozilla.org/en-US/docs/Web/API/CSSStyleRule
  matchStyleRule() {
    const e = this.formatSelector(!0);
    return this.scopecssDisableNextLine = !1, e ? (this.recordResult(e), this.matchComments(), this.styleDeclarations(), this.matchLeadingSpaces(), !0) : Z("selector missing", this.linkPath);
  }
  formatSelector(e) {
    const n = this.commonMatch(/^[^{]+/, e);
    return n ? n[0].replace(/(^|,[\n\s]*)([^,]+)/g, (r, o, i) => (i = et(i), this.scopecssDisableNextLine || this.scopecssDisable && (!this.scopecssDisableSelectors.length || this.scopecssDisableSelectors.includes(i)) || Cr.test(i) || (It.test(i) ? i = i.replace(It, this.prefix + " micro-app-body") : i = this.prefix + " " + i), o + i)) : !1;
  }
  // https://developer.mozilla.org/en-US/docs/Web/API/CSSStyleDeclaration
  styleDeclarations() {
    return this.matchOpenBrace() ? (this.matchAllDeclarations(), this.matchCloseBrace() ? !0 : Z("Declaration missing '}'", this.linkPath)) : Z("Declaration missing '{'", this.linkPath);
  }
  matchAllDeclarations(e = 1) {
    let n = this.commonMatch(/^(?:url\(["']?(?:[^)"'}]+)["']?\)|[^{}/])*/, !0)[0];
    if (n && (!this.scopecssDisableNextLine && (!this.scopecssDisable || this.scopecssDisableSelectors.length) && (n = n.replace(/url\(["']?([^)"']+)["']?\)/gm, (r, o) => /^((data|blob):|#)/.test(o) || /^(https?:)?\/\//.test(o) ? r : (/^((\.\.?\/)|[^/])/.test(o) && this.linkPath && (this.baseURI = Pr(this.linkPath)), `url("${G(o, this.baseURI)}")`))), this.recordResult(n)), this.scopecssDisableNextLine = !1, !!this.cssText)
      return this.cssText.charAt(0) === "}" ? e ? (e > 1 && this.commonMatch(/}+/), this.matchAllDeclarations(e - 1)) : void 0 : (this.cssText.charAt(0) === "/" && (this.cssText.charAt(1) === "*" ? this.matchComments() : this.commonMatch(/\/+/)), this.cssText.charAt(0) === "{" && (this.commonMatch(/{+\s*/), e++), this.matchAllDeclarations(e));
  }
  matchAtRule() {
    return this.cssText[0] !== "@" ? !1 : (this.scopecssDisableNextLine = !1, this.keyframesRule() || this.mediaRule() || this.customMediaRule() || this.supportsRule() || this.importRule() || this.charsetRule() || this.namespaceRule() || this.containerRule() || this.documentRule() || this.pageRule() || this.hostRule() || this.fontFaceRule());
  }
  // :global is CSS Modules rule, it will be converted to normal syntax
  // private matchGlobalRule (): boolean | void {
  //   if (this.cssText[0] !== ':') return false
  //   // reset scopecssDisableNextLine
  //   this.scopecssDisableNextLine = false
  //   return this.globalRule()
  // }
  // https://developer.mozilla.org/en-US/docs/Web/API/CSSKeyframesRule
  keyframesRule() {
    if (!this.commonMatch(/^@([-\w]+)?keyframes\s*/))
      return !1;
    if (!this.commonMatch(/^[^{]+/))
      return Z("@keyframes missing name", this.linkPath);
    if (this.matchComments(), !this.matchOpenBrace())
      return Z("@keyframes missing '{'", this.linkPath);
    for (this.matchComments(); this.keyframeRule(); )
      this.matchComments();
    return this.matchCloseBrace() ? (this.matchLeadingSpaces(), !0) : Z("@keyframes missing '}'", this.linkPath);
  }
  keyframeRule() {
    let e;
    const n = [];
    for (; e = this.commonMatch(/^((\d+\.\d+|\.\d+|\d+)%?|[a-z]+)\s*/); )
      n.push(e[1]), this.commonMatch(/^,\s*/);
    return n.length ? (this.styleDeclarations(), this.matchLeadingSpaces(), !0) : !1;
  }
  // https://github.com/postcss/postcss-custom-media
  customMediaRule() {
    return this.commonMatch(/^@custom-media\s+(--[^\s]+)\s*([^{;]+);/) ? (this.matchLeadingSpaces(), !0) : !1;
  }
  // https://developer.mozilla.org/en-US/docs/Web/API/CSSPageRule
  pageRule() {
    return this.commonMatch(/^@page */) ? (this.formatSelector(!1), this.scopecssDisableNextLine = !1, this.commonHandlerForAtRuleWithSelfRule("page")) : !1;
  }
  // https://developer.mozilla.org/en-US/docs/Web/API/CSSFontFaceRule
  fontFaceRule() {
    return this.commonMatch(/^@font-face\s*/) ? this.commonHandlerForAtRuleWithSelfRule("font-face") : !1;
  }
  // common matcher for @media, @supports, @document, @host, :global, @container
  createMatcherForRuleWithChildRule(e, n) {
    return () => this.commonMatch(e) ? this.matchOpenBrace() ? (this.matchComments(), this.matchRules(), this.matchCloseBrace() ? (this.matchLeadingSpaces(), !0) : Z(`${n} missing '}'`, this.linkPath)) : Z(`${n} missing '{'`, this.linkPath) : !1;
  }
  // common matcher for @import, @charset, @namespace
  createMatcherForNoneBraceAtRule(e) {
    const n = new RegExp("^@" + e + "\\s*([^;]+);");
    return () => this.commonMatch(n) ? (this.matchLeadingSpaces(), !0) : !1;
  }
  // common handler for @font-face, @page
  commonHandlerForAtRuleWithSelfRule(e) {
    return this.matchOpenBrace() ? (this.matchAllDeclarations(), this.matchCloseBrace() ? (this.matchLeadingSpaces(), !0) : Z(`@${e} missing '}'`, this.linkPath)) : Z(`@${e} missing '{'`, this.linkPath);
  }
  // match and slice comments
  matchComments() {
    for (; this.matchComment(); )
      ;
  }
  // css comment
  matchComment() {
    if (this.cssText.charAt(0) !== "/" || this.cssText.charAt(1) !== "*")
      return !1;
    this.scopecssDisableNextLine = !1;
    let e = 2;
    for (; this.cssText.charAt(e) !== "" && (this.cssText.charAt(e) !== "*" || this.cssText.charAt(e + 1) !== "/"); )
      ++e;
    if (e += 2, this.cssText.charAt(e - 1) === "")
      return Z("End of comment missing", this.linkPath);
    let n = this.cssText.slice(2, e - 2);
    return this.recordResult(`/*${n}*/`), n = et(n.replace(/^\s*!/, "")), n === "scopecss-disable-next-line" ? this.scopecssDisableNextLine = !0 : /^scopecss-disable/.test(n) ? n === "scopecss-disable" ? this.scopecssDisable = !0 : (this.scopecssDisable = !0, n.replace("scopecss-disable", "").split(",").forEach((o) => {
      this.scopecssDisableSelectors.push(et(o));
    })) : n === "scopecss-enable" && (this.scopecssDisable = !1, this.scopecssDisableSelectors = []), this.cssText = this.cssText.slice(e), this.matchLeadingSpaces(), !0;
  }
  commonMatch(e, n = !1) {
    const r = e.exec(this.cssText);
    if (!r)
      return;
    const o = r[0];
    return this.cssText = this.cssText.slice(o.length), n || this.recordResult(o), r;
  }
  matchOpenBrace() {
    return this.commonMatch(/^{\s*/);
  }
  matchCloseBrace() {
    return this.commonMatch(/^}/);
  }
  // match and slice the leading spaces
  matchLeadingSpaces() {
    this.commonMatch(/^\s*/);
  }
  // splice string
  recordResult(e) {
    Ot() ? this.result += encodeURIComponent(e) : this.result += e;
  }
}
function Nt(t, e, n, r, o) {
  if (!t.__MICRO_APP_HAS_SCOPED__) {
    t.__MICRO_APP_HAS_SCOPED__ = !0;
    let i = null;
    try {
      i = Se.exec(t.textContent, n, r, o), Se.reset();
    } catch (s) {
      Se.reset(), O(`An error occurred while parsing CSS:
`, e, s);
    }
    i && (t.textContent = i);
  }
}
let Se;
function _t(t, e, n) {
  if (e.scopecss) {
    const r = Et(e.name);
    if (Se || (Se = new Lr()), t.textContent)
      Nt(t, e.name, r, e.url, n);
    else {
      const o = new MutationObserver(function() {
        o.disconnect(), t.textContent && !t.hasAttribute("data-styled") && Nt(t, e.name, r, e.url, n);
      });
      o.observe(t, { childList: !0 });
    }
  }
  return t;
}
function Et(t, e = !1) {
  const n = e ? "\\" : "";
  return `${R.tagName}${n}[name=${t}${n}]`;
}
function Jt(t, e) {
  Object.defineProperties(t, {
    currentTarget: {
      get() {
        return e;
      }
    },
    srcElement: {
      get() {
        return e;
      }
    },
    target: {
      get() {
        return e;
      }
    }
  });
}
function Zt(t) {
  const e = new CustomEvent("load");
  Jt(e, t), y(t.onload) ? t.onload(e) : t.dispatchEvent(e);
}
function kt(t) {
  const e = new CustomEvent("error");
  Jt(e, t), y(t.onerror) ? t.onerror(e) : t.dispatchEvent(e);
}
function Ir() {
  const t = /* @__PURE__ */ new Map(), e = /* @__PURE__ */ new Map();
  function n(r) {
    return {
      setInfo(o, i) {
        r.set(o, i);
      },
      getInfo(o) {
        var i;
        return (i = r.get(o)) !== null && i !== void 0 ? i : null;
      },
      hasInfo(o) {
        return r.has(o);
      },
      deleteInfo(o) {
        return r.delete(o);
      }
    };
  }
  return {
    link: n(t),
    script: Object.assign(Object.assign({}, n(e)), { deleteInlineInfo(r) {
      r.forEach((o) => {
        Le(o) && e.delete(o);
      });
    } })
  };
}
var q = Ir();
function Nr(t, e, n) {
  const r = n.appSpace;
  for (const o in r)
    if (o !== t) {
      const i = r[o];
      if (i.parsedCode)
        return i.parsedCode.replace(new RegExp(Et(o, !0), "g"), e);
    }
}
function xr(t, e) {
  e.forEach((n, r) => {
    r !== "rel" && (r === "href" && (r = "data-origin-href"), l.rawSetAttribute.call(t, r, n));
  });
}
function en(t, e, n, r = !1) {
  const o = t.getAttribute("rel");
  let i = t.getAttribute("href"), s = null;
  if (o === "stylesheet" && i) {
    i = G(i, n.url);
    let a = q.link.getInfo(i);
    const c = {
      attrs: ct(t)
    };
    if (a ? a.appSpace[n.name] = a.appSpace[n.name] || c : a = {
      code: "",
      appSpace: {
        [n.name]: c
      }
    }, q.link.setInfo(i, a), !r)
      n.source.links.add(i), s = document.createComment(`link element with href=${i} move to micro-app-head as style element`), a.appSpace[n.name].placeholder = s;
    else
      return { address: i, linkInfo: a };
  } else
    o && ["prefetch", "preload", "prerender"].includes(o) ? r ? s = document.createComment(`link element with rel=${o}${i ? " & href=" + i : ""} removed by micro-app`) : e == null || e.removeChild(t) : i && l.rawSetAttribute.call(t, "href", G(i, n.url));
  if (r)
    return { replaceComment: s };
  if (s)
    return e == null ? void 0 : e.replaceChild(s, t);
}
function Tr(t, e, n, r) {
  const o = Array.from(e.source.links), i = o.map((a) => {
    const c = q.link.getInfo(a);
    return c.code ? c.code : pe(a, e.name);
  }), s = r ? [] : null;
  Ye(i, (a) => {
    De(s, () => Br(o[a.index], a.data, n, e));
  }, (a) => {
    O(a, e.name);
  }, () => {
    r ? r.then(() => {
      s.push(() => Promise.resolve(e.onLoad({ html: t }))), Ce(s);
    }) : e.onLoad({ html: t });
  });
}
function Br(t, e, n, r) {
  const o = q.link.getInfo(t);
  o.code = e;
  const i = o.appSpace[r.name], s = i.placeholder;
  if (s) {
    const a = K("style");
    tn(r, t, a, o, i.attrs), s.parentNode ? s.parentNode.replaceChild(a, s) : n.appendChild(a), i.placeholder = null;
  }
}
function tn(t, e, n, r, o) {
  if (t.scopecss) {
    const i = r.appSpace[t.name];
    if (i.prefix = i.prefix || Et(t.name), i.parsedCode)
      n.textContent = i.parsedCode;
    else {
      const s = Nr(t.name, i.prefix, r);
      s ? n.textContent = s : (n.textContent = r.code, _t(n, t, e)), i.parsedCode = n.textContent;
    }
  } else
    n.textContent = r.code;
  xr(n, o);
}
function Ur(t, e, n, r) {
  const o = K("style"), i = () => {
    tn(e, t, o, n, n.appSpace[e.name].attrs), Zt(r);
  };
  return n.code ? X(i) : pe(t, e.name).then((s) => {
    n.code = s, i();
  }).catch((s) => {
    O(s, e.name), kt(r);
  }), o;
}
var ye;
(function(t) {
  t.NAME = "name", t.URL = "url";
})(ye || (ye = {}));
var U;
(function(t) {
  t.CREATED = "created", t.LOADING = "loading", t.LOAD_FAILED = "load_failed", t.BEFORE_MOUNT = "before_mount", t.MOUNTING = "mounting", t.MOUNTED = "mounted", t.UNMOUNT = "unmount";
})(U || (U = {}));
var C;
(function(t) {
  t.CREATED = "created", t.BEFOREMOUNT = "beforemount", t.MOUNTED = "mounted", t.UNMOUNT = "unmount", t.ERROR = "error", t.BEFORESHOW = "beforeshow", t.AFTERSHOW = "aftershow", t.AFTERHIDDEN = "afterhidden";
})(C || (C = {}));
var me;
(function(t) {
  t.ONMOUNT = "onmount", t.ONUNMOUNT = "onunmount";
})(me || (me = {}));
var Me;
(function(t) {
  t.KEEP_ALIVE_SHOW = "keep_alive_show", t.KEEP_ALIVE_HIDDEN = "keep_alive_hidden";
})(Me || (Me = {}));
var xt;
(function(t) {
  t.DESTROY = "destroy", t.DESTORY = "destory", t.INLINE = "inline", t.DISABLESCOPECSS = "disableScopecss", t.DISABLESANDBOX = "disableSandbox", t.DISABLE_SCOPECSS = "disable-scopecss", t.DISABLE_SANDBOX = "disable-sandbox", t.DISABLE_MEMORY_ROUTER = "disable-memory-router", t.DISABLE_PATCH_REQUEST = "disable-patch-request", t.KEEP_ROUTER_STATE = "keep-router-state", t.HIDDEN_ROUTER = "hidden-router", t.KEEP_ALIVE = "keep-alive", t.CLEAR_DATA = "clear-data", t.SSR = "ssr", t.FIBER = "fiber";
})(xt || (xt = {}));
const Tt = [1, 2, 3], Ie = "search", Ke = "native", nn = "native-scope", rn = "pure", Wr = [
  Ie,
  Ke,
  nn,
  rn
], on = [
  "popstate",
  "hashchange",
  "load",
  "beforeunload",
  "unload",
  "unmount",
  "appstate-change",
  "statechange",
  "mounted"
], sn = [
  "onpopstate",
  "onhashchange",
  "onload",
  "onbeforeunload",
  "onunload",
  "onerror"
], Fr = [
  "DOMContentLoaded",
  "readystatechange"
], Hr = [
  "onreadystatechange"
], an = [
  "window",
  "self",
  "globalThis"
], $r = ["rawWindow", "rawDocument"], Bt = "window,self,globalThis,document,Document,Array,Object,String,Boolean,Math,Number,Symbol,Date,Function,Proxy,WeakMap,WeakSet,Set,Map,Reflect,Element,Node,RegExp,Error,TypeError,JSON,isNaN,parseFloat,parseInt,performance,console,decodeURI,encodeURI,decodeURIComponent,encodeURIComponent,navigator,undefined,location,history", jr = ["text/javascript", "text/ecmascript", "application/javascript", "application/ecmascript", "module", "systemjs-module", "systemjs-importmap"];
function ce(t, e) {
  return e.appSpace[t.name].module && (!t.useSandbox || t.iframe);
}
function Gr(t, e) {
  return e.appSpace[t.name].attrs.has("id");
}
function Je(t, e) {
  return t.inline || e.appSpace[t.name].inline || ce(t, e) || Gr(t, e);
}
function cn(t) {
  return t.iframe ? t.sandBox.microAppWindow : l.rawWindow;
}
function Kr(t, e) {
  const n = cn(t);
  return new n.Function(e);
}
function qr(t, e, n) {
  const r = e.appSpace;
  for (const o in r)
    if (o !== t.name) {
      const i = r[o];
      if (i.parsedCode === n && i.parsedFunction)
        return i.parsedFunction;
    }
}
function ln(t, e, n) {
  return qr(t, e, n) || Kr(t, n);
}
function un() {
  const t = Rr();
  return q.script.hasInfo(t) ? un() : t;
}
function Qr(t, e) {
  e.forEach((n, r) => {
    r === "type" && n === "module" || r === "defer" || r === "async" || (r === "src" && (r = "data-origin-src"), l.rawSetAttribute.call(t, r, n));
  });
}
function hn(t, e) {
  return t.useSandbox && !ce(t, e);
}
function dn(t, e) {
  return hn(t, e) ? t.iframe ? "iframe" : "with" : "disable";
}
function fn(t, e, n, r = !1) {
  var o;
  let i = null, s = t.getAttribute("src");
  if (s && (s = G(s, n.url)), t.hasAttribute("exclude") || At(s, n.name))
    i = document.createComment("script element with exclude attribute removed by micro-app");
  else {
    if (t.type && !jr.includes(t.type) || t.hasAttribute("ignore") || wt(s, n.name))
      return !((o = l.rawDocument) === null || o === void 0) && o.currentScript && delete l.rawDocument.currentScript, null;
    if (l.supportModuleScript && t.noModule || !l.supportModuleScript && t.type === "module")
      i = document.createComment(`${t.noModule ? "noModule" : "module"} script ignored by micro-app`);
    else if (s) {
      let a = q.script.getInfo(s);
      const c = {
        async: t.hasAttribute("async"),
        defer: t.defer || t.type === "module",
        module: t.type === "module",
        inline: t.hasAttribute("inline"),
        pure: t.hasAttribute("pure"),
        attrs: ct(t)
      };
      if (a ? a.appSpace[n.name] = a.appSpace[n.name] || c : a = {
        code: "",
        isExternal: !0,
        appSpace: {
          [n.name]: c
        }
      }, q.script.setInfo(s, a), !r)
        n.source.scripts.add(s), i = document.createComment(`script with src='${s}' extract by micro-app`);
      else
        return { address: s, scriptInfo: a };
    } else if (t.textContent) {
      const a = un(), c = {
        code: t.textContent,
        isExternal: !1,
        appSpace: {
          [n.name]: {
            async: !1,
            defer: t.type === "module",
            module: t.type === "module",
            inline: t.hasAttribute("inline"),
            pure: t.hasAttribute("pure"),
            attrs: ct(t)
          }
        }
      };
      if (!r)
        n.source.scripts.add(a), q.script.setInfo(a, c), i = document.createComment("inline script extract by micro-app");
      else
        return { address: a, scriptInfo: c };
    } else
      r || (i = document.createComment("script element removed by micro-app"));
  }
  return r ? { replaceComment: i } : e == null ? void 0 : e.replaceChild(i, t);
}
function pn(t) {
  var e, n, r;
  const o = ((e = R.options.plugins) === null || e === void 0 ? void 0 : e.global) || [], i = ((r = (n = R.options.plugins) === null || n === void 0 ? void 0 : n.modules) === null || r === void 0 ? void 0 : r[t]) || [];
  return [...o, ...i];
}
function At(t, e) {
  return t ? (pn(e) || []).some((r) => r.excludeChecker ? r.excludeChecker(t) : !1) : !1;
}
function wt(t, e) {
  return t ? (pn(e) || []).some((r) => r.ignoreChecker ? r.ignoreChecker(t) : !1) : !1;
}
function Vr(t, e) {
  const n = Array.from(e.source.scripts), r = [], o = [];
  for (const s of n) {
    const a = q.script.getInfo(s), c = a.appSpace[e.name];
    (!c.defer && !c.async || e.isPrefetch && !e.isPrerender) && (r.push(a.code ? a.code : pe(s, e.name)), o.push([s, a]));
  }
  const i = e.isPrefetch || e.fiber ? [] : null;
  r.length ? Ye(r, (s) => {
    De(i, () => Xr(o[s.index][0], o[s.index][1], s.data, e));
  }, (s) => {
    O(s, e.name);
  }, () => {
    i ? (i.push(() => Promise.resolve(e.onLoad({ html: t }))), Ce(i)) : e.onLoad({ html: t });
  }) : e.onLoad({ html: t });
}
function Xr(t, e, n, r) {
  if (e.code = n, r.isPrefetch && r.prefetchLevel === 2) {
    const o = e.appSpace[r.name];
    if (!o.parsedCode && (o.parsedCode = mn(t, r, n, e), o.sandboxType = dn(r, e), !Je(r, e)))
      try {
        o.parsedFunction = ln(r, e, o.parsedCode);
      } catch (i) {
        O("Something went wrong while handling preloaded resources", r.name, `
`, i);
      }
  }
}
function Yr(t, e) {
  const n = t.fiber ? [] : null, r = Array.from(t.source.scripts), o = [], i = [];
  for (const s of r) {
    const a = q.script.getInfo(s), c = a.appSpace[t.name];
    c.defer || c.async ? (a.isExternal && !a.code && !ce(t, a) ? o.push(pe(s, t.name)) : o.push(a.code), i.push([s, a]), ce(t, a) && (e.moduleCount = e.moduleCount ? ++e.moduleCount : 1)) : De(n, () => {
      qe(s, t, a), e(!1);
    });
  }
  o.length ? Ye(o, (s) => {
    const a = i[s.index][1];
    a.code = a.code || s.data;
  }, (s) => {
    e.errorCount = e.errorCount ? ++e.errorCount : 1, O(s, t.name);
  }, () => {
    i.forEach(([s, a]) => {
      I(a.code) && De(n, () => {
        qe(s, t, a, e), !ce(t, a) && e(!1);
      });
    }), n ? (n.push(() => Promise.resolve(e(de(e.moduleCount) || e.errorCount === o.length))), Ce(n)) : e(de(e.moduleCount) || e.errorCount === o.length);
  }) : n ? (n.push(() => Promise.resolve(e(!0))), Ce(n)) : e(!0);
}
function qe(t, e, n, r, o) {
  try {
    eo(e);
    const i = n.appSpace[e.name], s = dn(e, n);
    if ((!i.parsedCode || i.sandboxType !== s) && (i.parsedCode = mn(t, e, n.code, n), i.sandboxType = s, i.parsedFunction = null), Je(e, n)) {
      const a = o || K("script");
      if (Zr(t, i.parsedCode, ce(e, n), a, i.attrs, r), !o) {
        const c = e.iframe ? e.sandBox.microBody : e.querySelector("micro-app-body");
        c == null || c.appendChild(a);
      }
    } else
      kr(e, n);
  } catch (i) {
    throw console.error(`[micro-app from ${o ? "runDynamicScript" : "runScript"}] app ${e.name}: `, i, t), i;
  }
}
function zr(t, e, n, r) {
  const o = Je(e, n) ? K("script") : document.createComment("dynamic script extract by micro-app"), i = () => Zt(r), s = () => {
    const a = Object.getOwnPropertyDescriptor(l.rawDocument, "currentScript");
    (!a || a.configurable) && Object.defineProperty(l.rawDocument, "currentScript", {
      value: r,
      configurable: !0
    }), qe(t, e, n, i, o), !ce(e, n) && i();
  };
  return n.code || ce(e, n) ? X(s) : pe(t, e.name).then((a) => {
    n.code = a, s();
  }).catch((a) => {
    O(a, e.name), kt(r);
  }), o;
}
function Jr(t, e, n) {
  const r = Je(e, n) ? K("script") : document.createComment("dynamic script extract by micro-app");
  return qe(t, e, n, void 0, r), r;
}
function Zr(t, e, n, r, o, i) {
  if (n) {
    if (l.rawSetAttribute.call(r, "type", "module"), Le(t) ? r.textContent = e : r.src = t, i) {
      const s = () => {
        i.moduleCount && i.moduleCount--, i(i.moduleCount === 0);
      };
      Le(t) ? X(s) : r.onload = s;
    }
  } else
    r.textContent = e;
  Qr(r, o);
}
function kr(t, e) {
  const n = e.appSpace[t.name];
  n.parsedFunction || (n.parsedFunction = ln(t, e, n.parsedCode)), n.parsedFunction.call(cn(t));
}
function mn(t, e, n, r) {
  return T(R.options.plugins) && (n = no(t, n, e.name, R.options.plugins)), hn(e, r) ? e.iframe ? `(function(window,self,global,location){;${n}
${Le(t) ? "" : `//# sourceURL=${t}
`}}).call(window.__MICRO_APP_SANDBOX__.proxyWindow,window.__MICRO_APP_SANDBOX__.proxyWindow,window.__MICRO_APP_SANDBOX__.proxyWindow,window.__MICRO_APP_SANDBOX__.proxyWindow,window.__MICRO_APP_SANDBOX__.proxyLocation);` : `;(function(proxyWindow){with(proxyWindow.__MICRO_APP_WINDOW__){(function(${Bt}){;${n}
${Le(t) ? "" : `//# sourceURL=${t}
`}}).call(proxyWindow,${Bt})}})(window.__MICRO_APP_PROXY_WINDOW__);` : n;
}
function eo(t) {
  to(t);
}
function to(t) {
  t.sandBox && (l.rawWindow.__MICRO_APP_PROXY_WINDOW__ = t.sandBox.proxyWindow);
}
function no(t, e, n, r) {
  var o;
  const i = Ut(r.global, e, t);
  return Ut((o = r.modules) === null || o === void 0 ? void 0 : o[n], i, t);
}
function Ut(t, e, n) {
  return ee(t) ? t.reduce((r, o) => T(o) && y(o.loader) ? o.loader(r, n) : r, e) : e;
}
function _n(t, e, n, r) {
  const o = Array.from(t.children);
  o.length && o.forEach((i) => {
    _n(i, e, n, r);
  });
  for (const i of o)
    Yt(i) ? i.hasAttribute("exclude") || At(i.getAttribute("href"), e.name) ? t.replaceChild(document.createComment("link element with exclude attribute ignored by micro-app"), i) : i.hasAttribute("ignore") || wt(i.getAttribute("href"), e.name) ? i.hasAttribute("href") && l.rawSetAttribute.call(i, "href", G(i.getAttribute("href"), e.url)) : en(i, t, e) : dt(i) ? i.hasAttribute("exclude") ? t.replaceChild(document.createComment("style element with exclude attribute ignored by micro-app"), i) : e.scopecss && !i.hasAttribute("ignore") && De(r, () => _t(i, e)) : Ee(i) ? fn(i, t, e) : wr(i) && i.hasAttribute("src") && l.rawSetAttribute.call(i, "src", G(i.getAttribute("src"), e.url));
}
function ro(t, e) {
  const n = e.parseHtmlString(t), r = l.rawElementQuerySelector.call(n, "micro-app-head"), o = l.rawElementQuerySelector.call(n, "micro-app-body");
  if (!r || !o) {
    const a = `element ${r ? "body" : "head"} is missing`;
    return e.onerror(new Error(a)), O(a, e.name);
  }
  const i = e.isPrefetch || e.fiber ? [] : null;
  _n(n, e, r, i);
  const s = Ce(i);
  e.source.links.size ? Tr(n, e, r, s) : s ? s.then(() => e.onLoad({ html: n })) : e.onLoad({ html: n }), e.source.scripts.size ? Vr(n, e) : e.onLoad({ html: n });
}
class oo {
  constructor() {
    this.eventList = /* @__PURE__ */ new Map(), this.queue = [], this.recordStep = {}, this.process = () => {
      var e, n;
      let r;
      const o = this.recordStep, i = this.queue;
      for (this.recordStep = {}, this.queue = []; r = i.shift(); ) {
        const s = this.eventList.get(r), a = s.tempData, c = s.force;
        s.tempData = null, s.force = !1;
        let A;
        if (c || !this.isEqual(s.data, a)) {
          s.data = a || s.data;
          for (const m of s.callbacks) {
            const v = m(s.data);
            v && (A ?? (A = [])).push(v);
          }
          (n = (e = o[r]).dispatchDataEvent) === null || n === void 0 || n.call(e), o[r].nextStepList.forEach((m) => m(A));
        }
      }
    };
  }
  // whether the name is legal
  isLegalName(e) {
    return e ? !0 : (O("event-center: Invalid name"), !1);
  }
  // add appName to queue
  enqueue(e, n, r) {
    this.recordStep[e] ? (this.recordStep[e].nextStepList.push(n), r && (this.recordStep[e].dispatchDataEvent = r)) : this.recordStep[e] = {
      nextStepList: [n],
      dispatchDataEvent: r
    }, !this.queue.includes(e) && this.queue.push(e) === 1 && X(this.process);
  }
  /**
   * In react, each setState will trigger setData, so we need a filter operation to avoid repeated trigger
   */
  isEqual(e, n) {
    if (!n || Object.keys(e).length !== Object.keys(n).length)
      return !1;
    for (const r in e)
      if (Object.prototype.hasOwnProperty.call(e, r) && e[r] !== n[r])
        return !1;
    return !0;
  }
  /**
   * add listener
   * @param name event name
   * @param f listener
   * @param autoTrigger If there is cached data when first bind listener, whether it needs to trigger, default is false
   */
  on(e, n, r = !1) {
    if (this.isLegalName(e)) {
      if (!y(n))
        return O("event-center: Invalid callback function");
      let o = this.eventList.get(e);
      o ? r && Object.keys(o.data).length && (!this.queue.includes(e) || this.isEqual(o.data, o.tempData)) && n(o.data) : (o = {
        data: {},
        callbacks: /* @__PURE__ */ new Set()
      }, this.eventList.set(e, o)), o.callbacks.add(n);
    }
  }
  // remove listener, but the data is not cleared
  off(e, n) {
    if (this.isLegalName(e)) {
      const r = this.eventList.get(e);
      r && (y(n) ? r.callbacks.delete(n) : r.callbacks.clear());
    }
  }
  /**
   * clearData
   */
  clearData(e) {
    if (this.isLegalName(e)) {
      const n = this.eventList.get(e);
      n && (n.data = {});
    }
  }
  // dispatch data
  dispatch(e, n, r, o, i) {
    if (this.isLegalName(e)) {
      if (!T(n))
        return O("event-center: data must be object");
      let s = this.eventList.get(e);
      s ? (s.tempData = z({}, s.tempData || s.data, n), !s.force && (s.force = !!o)) : (s = {
        data: n,
        callbacks: /* @__PURE__ */ new Set()
      }, this.eventList.set(e, s), s.force = !0), this.enqueue(e, r, i);
    }
  }
  // get data
  getData(e) {
    var n;
    const r = this.eventList.get(e);
    return (n = r == null ? void 0 : r.data) !== null && n !== void 0 ? n : null;
  }
}
const N = new oo();
function H(t, e) {
  return !I(t) || !t ? "" : e ? `__from_base_app_${t}__` : `__from_micro_app_${t}__`;
}
class En {
  /**
   * add listener of global data
   * @param cb listener
   * @param autoTrigger If there is cached data when first bind listener, whether it needs to trigger, default is false
   */
  addGlobalDataListener(e, n) {
    const r = this.appName;
    r && (e.__APP_NAME__ = r, e.__AUTO_TRIGGER__ = n), N.on("global", e, n);
  }
  /**
   * remove listener of global data
   * @param cb listener
   */
  removeGlobalDataListener(e) {
    y(e) && N.off("global", e);
  }
  /**
   * dispatch global data
   * @param data data
   */
  setGlobalData(e, n, r) {
    B(), N.dispatch("global", e, (o) => y(n) && n(o), r);
  }
  forceSetGlobalData(e, n) {
    this.setGlobalData(e, n, !0);
  }
  /**
   * get global data
   */
  getGlobalData() {
    return N.getData("global");
  }
  /**
   * clear global data
   */
  clearGlobalData() {
    N.clearData("global");
  }
  /**
   * clear all listener of global data
   * if appName exists, only the specified functions is cleared
   * if appName not exists, only clear the base app functions
   */
  clearGlobalDataListener() {
    const e = this.appName, n = N.eventList.get("global");
    if (n)
      for (const r of n.callbacks)
        (e && e === r.__APP_NAME__ || !(e || r.__APP_NAME__)) && n.callbacks.delete(r);
  }
}
class io extends En {
  /**
   * add listener
   * @param appName app.name
   * @param cb listener
   * @param autoTrigger If there is cached data when first bind listener, whether it needs to trigger, default is false
   */
  addDataListener(e, n, r) {
    N.on(H(W(e), !1), n, r);
  }
  /**
   * remove listener
   * @param appName app.name
   * @param cb listener
   */
  removeDataListener(e, n) {
    y(n) && N.off(H(W(e), !1), n);
  }
  /**
   * get data from micro app or base app
   * @param appName app.name
   * @param fromBaseApp whether get data from base app, default is false
   */
  getData(e, n = !1) {
    return N.getData(H(W(e), n));
  }
  /**
   * Dispatch data to the specified micro app
   * @param appName app.name
   * @param data data
   */
  setData(e, n, r, o) {
    N.dispatch(H(W(e), !0), n, (i) => y(r) && r(i), o);
  }
  forceSetData(e, n, r) {
    this.setData(e, n, r, !0);
  }
  /**
   * clear data from base app
   * @param appName app.name
   * @param fromBaseApp whether clear data from child app, default is true
   */
  clearData(e, n = !0) {
    N.clearData(H(W(e), n));
  }
  /**
   * clear all listener for specified micro app
   * @param appName app.name
   */
  clearDataListener(e) {
    N.off(H(W(e), !1));
  }
}
class An extends En {
  constructor(e) {
    super(), this.appName = W(e), !this.appName && O(`Invalid appName ${e}`);
  }
  /**
   * add listener, monitor the data sent by the base app
   * @param cb listener
   * @param autoTrigger If there is cached data when first bind listener, whether it needs to trigger, default is false
   */
  addDataListener(e, n) {
    e.__AUTO_TRIGGER__ = n, N.on(H(this.appName, !0), e, n);
  }
  /**
   * remove listener
   * @param cb listener
   */
  removeDataListener(e) {
    y(e) && N.off(H(this.appName, !0), e);
  }
  /**
   * get data from base app
   */
  getData(e = !0) {
    return N.getData(H(this.appName, e));
  }
  /**
   * dispatch data to base app
   * @param data data
   */
  dispatch(e, n, r) {
    B(), N.dispatch(H(this.appName, !1), e, (o) => y(n) && n(o), r, () => {
      const o = P.get(this.appName);
      if (o != null && o.container && T(e)) {
        const i = new CustomEvent("datachange", {
          detail: {
            data: N.getData(H(this.appName, !1))
          }
        });
        re(o.container).dispatchEvent(i);
      }
    });
  }
  forceDispatch(e, n) {
    this.dispatch(e, n, !0);
  }
  /**
   * clear data from child app
   * @param fromBaseApp whether clear data from base app, default is false
   */
  clearData(e = !1) {
    N.clearData(H(this.appName, e));
  }
  /**
   * clear all listeners
   */
  clearDataListener() {
    N.off(H(this.appName, !0));
  }
}
function wn(t) {
  var e, n;
  if (t) {
    t.umdDataListeners = {
      global: new Set((e = t.umdDataListeners) === null || e === void 0 ? void 0 : e.global),
      normal: new Set((n = t.umdDataListeners) === null || n === void 0 ? void 0 : n.normal)
    };
    const r = N.eventList.get("global");
    if (r)
      for (const i of r.callbacks)
        t.appName === i.__APP_NAME__ && t.umdDataListeners.global.add(i);
    const o = N.eventList.get(H(t.appName, !0));
    if (o)
      for (const i of o.callbacks)
        t.umdDataListeners.normal.add(i);
  }
}
function vn(t) {
  if (t != null && t.umdDataListeners) {
    for (const e of t.umdDataListeners.global)
      t.addGlobalDataListener(e, e.__AUTO_TRIGGER__);
    for (const e of t.umdDataListeners.normal)
      t.addDataListener(e, e.__AUTO_TRIGGER__);
    vt(t);
  }
}
function vt(t) {
  t == null || delete t.umdDataListeners;
}
class Qe {
  constructor() {
    this.appInstanceMap = P;
  }
  static getInstance() {
    return this.instance || (this.instance = new Qe()), this.instance;
  }
  get(e) {
    return this.appInstanceMap.get(e);
  }
  set(e, n) {
    this.appInstanceMap.set(e, n);
  }
  getAll() {
    return Array.from(this.appInstanceMap.values());
  }
  clear() {
    this.appInstanceMap.clear();
  }
}
function gn() {
  Pn(), Qe.getInstance().getAll().forEach((t) => {
    t.container && re(t.container).disconnectedCallback();
  }), !window.__MICRO_APP_UMD_MODE__ && Qe.getInstance().clear();
}
function Pn() {
  window.__MICRO_APP_ENVIRONMENT__ && window.removeEventListener("unmount", gn, !1);
}
function so() {
  window.__MICRO_APP_ENVIRONMENT__ && (Pn(), window.addEventListener("unmount", gn, !1));
}
function ao(t) {
  return Vt(t.__MICRO_APP_IS_BOUND_FUNCTION__) ? t.__MICRO_APP_IS_BOUND_FUNCTION__ : t.__MICRO_APP_IS_BOUND_FUNCTION__ = mr(t);
}
function co(t) {
  return Vt(t.__MICRO_APP_IS_CONSTRUCTOR__) ? t.__MICRO_APP_IS_CONSTRUCTOR__ : t.__MICRO_APP_IS_CONSTRUCTOR__ = ht(t);
}
function Q(t, e, n = "WINDOW") {
  if (y(t) && !co(t) && !ao(t)) {
    const r = `__MICRO_APP_BOUND_${n}_FUNCTION__`;
    if (t[r])
      return t[r];
    const o = t.bind(e);
    for (const i in t)
      o[i] = t[i];
    return t.hasOwnProperty("prototype") && F(o, "prototype", {
      value: t.prototype,
      configurable: !0,
      enumerable: !1,
      writable: !0
    }), t[r] = o;
  }
  return t;
}
function lo(t, e, n) {
  const { proxyDocument: r, documentEffect: o } = uo(t, n), i = ho(t, r);
  return ie(e, {
    document: {
      configurable: !1,
      enumerable: !0,
      get() {
        return r;
      }
    },
    Document: {
      configurable: !1,
      enumerable: !1,
      get() {
        return i;
      }
    }
  }), o;
}
function uo(t, e) {
  const n = /* @__PURE__ */ new Map(), r = /* @__PURE__ */ new Map();
  let o = null, i = null;
  const { rawDocument: s, rawCreateElement: a, rawCreateElementNS: c, rawAddEventListener: A, rawRemoveEventListener: m } = l;
  function v(u, h) {
    const E = a.call(s, u, h);
    return E.__MICRO_APP_NAME__ = t, E;
  }
  function b(u, h, E) {
    const L = c.call(s, u, h, E);
    return L.__MICRO_APP_NAME__ = t, L;
  }
  function M(u, h, E) {
    const L = n.get(u);
    L ? L.add(h) : n.set(u, /* @__PURE__ */ new Set([h])), h && (h.__MICRO_APP_MARK_OPTIONS__ = E), A.call(s, u, h, E);
  }
  function D(u, h, E) {
    const L = n.get(u);
    L != null && L.size && L.has(h) && L.delete(h), m.call(s, u, h, E);
  }
  const g = () => {
    r.clear(), i = null;
  }, S = () => {
    i = o || i, n.forEach((u, h) => {
      if (u.size) {
        const E = r.get(h) || [];
        r.set(h, /* @__PURE__ */ new Set([...E, ...u]));
      }
    });
  }, _ = () => {
    i && !o && (w.onclick = i), r.forEach((u, h) => {
      for (const E of u)
        w.addEventListener(h, E, E == null ? void 0 : E.__MICRO_APP_MARK_OPTIONS__);
    }), g();
  }, p = () => {
    y(o) && m.call(s, "click", o), o = null, n.size && (n.forEach((u, h) => {
      for (const E of u)
        m.call(s, h, E);
    }), n.clear());
  }, f = (() => {
    var u;
    const h = /* @__PURE__ */ new Map([
      ["onclick", (be) => {
        y(o) && m.call(s, "click", o, !1), y(be) && A.call(s, "click", be, !1), o = be;
      }]
    ]), E = ((u = R.options) === null || u === void 0 ? void 0 : u.customProxyDocumentProps) || /* @__PURE__ */ new Map();
    return new Map([
      ...h,
      ...E
    ]);
  })(), w = new Proxy(s, {
    get: (u, h) => {
      var E;
      return fe(t), h === "createElement" ? v : h === "createElementNS" ? b : h === Symbol.toStringTag ? "ProxyDocument" : h === "defaultView" ? e.proxyWindow : h === "onclick" ? o : h === "addEventListener" ? M : h === "removeEventListener" ? D : h === "microAppElement" ? (E = P.get(t)) === null || E === void 0 ? void 0 : E.container : h === "__MICRO_APP_NAME__" ? t : Q(Reflect.get(u, h), s, "DOCUMENT");
    },
    set: (u, h, E) => (f.has(h) ? f.get(h)(E) : h !== "microAppElement" && Reflect.set(u, h, E), !0)
  });
  return {
    proxyDocument: w,
    documentEffect: {
      reset: g,
      record: S,
      rebuild: _,
      release: p
    }
  };
}
function ho(t, e) {
  const { rawDocument: n, rawRootDocument: r } = l;
  class o {
    static [Symbol.hasInstance](s) {
      let a = s;
      for (; a; )
        if (a = Object.getPrototypeOf(a), a === o.prototype)
          return !0;
      return s === e || s instanceof r;
    }
  }
  return Object.setPrototypeOf(o, r), Object.setPrototypeOf(o.prototype, new Proxy(r.prototype, {
    get(i, s) {
      return fe(t), Q(Reflect.get(i, s), n, "DOCUMENT");
    },
    set(i, s, a) {
      return Reflect.set(i, s, a), !0;
    }
  })), o;
}
function fo(t, e, n) {
  return po(e), mo(t, e, n), _o(e, t);
}
function po(t) {
  const e = l.rawWindow;
  Object.getOwnPropertyNames(e).filter((n) => /^on/.test(n) && !sn.includes(n)).forEach((n) => {
    const { enumerable: r, writable: o, set: i } = Object.getOwnPropertyDescriptor(e, n) || {
      enumerable: !0,
      writable: !0
    };
    F(t, n, {
      enumerable: r,
      configurable: !0,
      get: () => e[n],
      set: o ?? !!i ? (s) => {
        e[n] = s;
      } : void 0
    });
  });
}
function mo(t, e, n) {
  const r = l.rawWindow, o = /* @__PURE__ */ new Map(), i = new Proxy(e, {
    get: (s, a) => (fe(t), Reflect.has(s, a) || I(a) && /^__MICRO_APP_/.test(a) || V(n.scopeProperties, a) ? (V($r, a) && B(), Reflect.get(s, a)) : Q(Reflect.get(r, a), r)),
    set: (s, a, c) => {
      if (V(n.rawWindowScopeKeyList, a))
        Reflect.set(r, a, c);
      else if (
        // target.hasOwnProperty has been rewritten
        !ue.call(s, a) && ue.call(r, a) && !V(n.scopeProperties, a)
      ) {
        const A = Object.getOwnPropertyDescriptor(r, a), { configurable: m, enumerable: v, writable: b, set: M } = A;
        F(s, a, {
          value: c,
          configurable: m,
          enumerable: v,
          writable: b ?? !!M
        }), n.injectedKeys.add(a);
      } else
        (!Reflect.has(s, a) || V(n.scopeProperties, a)) && n.injectedKeys.add(a), Reflect.set(s, a, c);
      return (V(n.escapeProperties, a) || // TODO: staticEscapeProperties 合并到 escapeProperties
      V(n.staticEscapeProperties, a) && !Reflect.has(r, a)) && !V(n.scopeProperties, a) && (!Reflect.has(r, a) && n.escapeKeys.add(a), Reflect.set(r, a, c)), !0;
    },
    has: (s, a) => V(n.scopeProperties, a) ? n.injectedKeys.has(a) ? Reflect.has(s, a) : !!s[a] : Reflect.has(s, a) || Reflect.has(r, a),
    // Object.getOwnPropertyDescriptor(window, key)
    getOwnPropertyDescriptor: (s, a) => {
      if (ue.call(s, a))
        return o.set(a, "target"), Object.getOwnPropertyDescriptor(s, a);
      if (ue.call(r, a)) {
        o.set(a, "rawWindow");
        const c = Object.getOwnPropertyDescriptor(r, a);
        return c && !c.configurable && (c.configurable = !0), c;
      }
    },
    // Object.defineProperty(window, key, Descriptor)
    defineProperty: (s, a, c) => o.get(a) === "rawWindow" ? Reflect.defineProperty(r, a, c) : Reflect.defineProperty(s, a, c),
    // Object.getOwnPropertyNames(window)
    ownKeys: (s) => Sr(Reflect.ownKeys(r).concat(Reflect.ownKeys(s))),
    deleteProperty: (s, a) => ue.call(s, a) ? (n.injectedKeys.has(a) && n.injectedKeys.delete(a), n.escapeKeys.has(a) && Reflect.deleteProperty(r, a), Reflect.deleteProperty(s, a)) : !0
  });
  n.proxyWindow = i;
}
function _o(t, e) {
  const n = /* @__PURE__ */ new Map(), r = /* @__PURE__ */ new Map(), o = /* @__PURE__ */ new Map(), i = /* @__PURE__ */ new Map(), { rawWindow: s, rawAddEventListener: a, rawRemoveEventListener: c, rawDispatchEvent: A, rawSetInterval: m, rawSetTimeout: v, rawClearInterval: b, rawClearTimeout: M } = l;
  function D(d) {
    var f;
    return on.includes(d) && (!((f = P.get(e)) === null || f === void 0) && f.container) ? re(P.get(e).container) : s;
  }
  t.addEventListener = function(d, f, w) {
    const u = n.get(d);
    u ? u.add(f) : n.set(d, /* @__PURE__ */ new Set([f])), f && (f.__MICRO_APP_MARK_OPTIONS__ = w), a.call(D(d), d, f, w);
  }, t.removeEventListener = function(d, f, w) {
    const u = n.get(d);
    u != null && u.size && u.has(f) && u.delete(f), c.call(D(d), d, f, w);
  }, t.dispatchEvent = function(d) {
    return A.call(D(d == null ? void 0 : d.type), d);
  }, t.setInterval = function(d, f, ...w) {
    const u = m.call(s, d, f, ...w);
    return o.set(u, { handler: d, timeout: f, args: w }), u;
  }, t.setTimeout = function(d, f, ...w) {
    const u = v.call(s, d, f, ...w);
    return i.set(u, { handler: d, timeout: f, args: w }), u;
  }, t.clearInterval = function(d) {
    o.delete(d), b.call(s, d);
  }, t.clearTimeout = function(d) {
    i.delete(d), M.call(s, d);
  };
  const g = () => {
    r.clear();
  };
  return {
    reset: g,
    record: () => {
      n.forEach((d, f) => {
        if (d.size) {
          const w = r.get(f) || [];
          r.set(f, /* @__PURE__ */ new Set([...w, ...d]));
        }
      });
    },
    rebuild: () => {
      r.forEach((d, f) => {
        for (const w of d)
          t.addEventListener(f, w, w == null ? void 0 : w.__MICRO_APP_MARK_OPTIONS__);
      }), g();
    },
    release: (d) => {
      n.size && (n.forEach((f, w) => {
        for (const u of f)
          c.call(D(w), w, u);
      }), n.clear()), d && (o.forEach((f, w) => {
        b.call(s, w);
      }), i.forEach((f, w) => {
        M.call(s, w);
      }), o.clear(), i.clear());
    }
  };
}
function Ne(t, e) {
  if (J(t)) {
    const n = l.rawWindow.history.state, r = {
      microAppState: z({}, n == null ? void 0 : n.microAppState, {
        [t]: e
      })
    };
    return z({}, n, r);
  }
  return e;
}
function Eo(t, e) {
  return J(t) ? (T(e == null ? void 0 : e.microAppState) && (de(e.microAppState[t]) || delete e.microAppState[t], Object.keys(e.microAppState).length || delete e.microAppState), z({}, e)) : e;
}
function We(t) {
  var e;
  const n = l.rawWindow.history.state;
  return J(t) ? ((e = n == null ? void 0 : n.microAppState) === null || e === void 0 ? void 0 : e[t]) || null : n;
}
const Ao = /&/g, wo = /=/g, bn = /%M1/g, Rn = /%M2/g;
function Sn(t) {
  return encodeURIComponent(gt(t).replace(Ao, "%M1").replace(wo, "%M2"));
}
function yn(t) {
  return gt(t).replace(bn, "&").replace(Rn, "=");
}
function gt(t) {
  try {
    const e = decodeURIComponent(t);
    return t === e || bn.test(e) || Rn.test(e) ? e : gt(e);
  } catch {
    return t;
  }
}
function Fe(t) {
  var e, n;
  if (ge(t))
    return null;
  const r = l.rawWindow.location;
  if (J(t)) {
    const o = Pt(r.search, r.hash), i = ((e = o.hashQuery) === null || e === void 0 ? void 0 : e[t]) || ((n = o.searchQuery) === null || n === void 0 ? void 0 : n[t]);
    return I(i) ? yn(i) : null;
  }
  return r.pathname + r.search + r.hash;
}
function le(t, e) {
  const n = e.pathname + e.search + e.hash;
  let r = !1;
  if (J(t)) {
    let { pathname: o, search: i, hash: s } = l.rawWindow.location;
    const a = Pt(i, s), c = Sn(n);
    return s && !i ? (r = !0, a.hashQuery ? a.hashQuery[t] = c : a.hashQuery = {
      [t]: c
    }, s = (s.includes("?") ? s.slice(0, s.indexOf("?") + 1) : s + "?") + Ge(a.hashQuery)) : (a.searchQuery ? a.searchQuery[t] = c : a.searchQuery = {
      [t]: c
    }, i = "?" + Ge(a.searchQuery)), {
      fullPath: o + i + s,
      isAttach2Hash: r
    };
  }
  return {
    fullPath: n,
    isAttach2Hash: r
  };
}
function vo(t, e) {
  var n, r, o, i;
  let { pathname: s, search: a, hash: c } = e || l.rawWindow.location, A = !1;
  if (J(t)) {
    const m = Pt(a, c);
    if (!((n = m.hashQuery) === null || n === void 0) && n[t]) {
      A = !0, (r = m.hashQuery) === null || r === void 0 || delete r[t];
      const v = Ge(m.hashQuery);
      c = c.slice(0, c.indexOf("?") + +!!v) + v;
    } else if (!((o = m.searchQuery) === null || o === void 0) && o[t]) {
      (i = m.searchQuery) === null || i === void 0 || delete i[t];
      const v = Ge(m.searchQuery);
      a = v ? "?" + v : "";
    }
  }
  return {
    fullPath: s + a + c,
    isAttach2Hash: A
  };
}
function Pt(t, e) {
  const n = {};
  return t !== "" && t !== "?" && (n.searchQuery = Dt(t.slice(1))), e.includes("?") && (n.hashQuery = Dt(e.slice(e.indexOf("?") + 1))), n;
}
function go(t, e) {
  const n = Fe(t);
  if (!n)
    return "";
  const r = x(n, e);
  return r.origin + r.pathname + r.search;
}
function xe(t) {
  const e = P.get(t);
  return !!(e && !e.isPrefetch);
}
function J(t) {
  const e = P.get(t);
  return !!(e && e.sandBox && e.routerMode === Ie);
}
function Mn(t) {
  const e = P.get(t);
  return !!(e && e.sandBox && e.routerMode === Ke);
}
function Po(t) {
  const e = P.get(t);
  return !!(e && e.sandBox && e.routerMode === nn);
}
function ge(t) {
  const e = P.get(t);
  return !!(e && e.sandBox && e.routerMode === rn);
}
function he(t) {
  return Mn(t) || Po(t);
}
function On(t, e) {
  const n = e && Ke || t || R.options["disable-memory-router"] && Ke || R.options["router-mode"] || Ie;
  return Wr.includes(n) ? n : Ie;
}
function Dn(t) {
  const e = l.rawWindow, n = (r) => {
    we({
      excludeHiddenApp: !0,
      excludePreRender: !0
    }).includes(t) && !r.onlyForBrowser && Cn(t, Fe(t));
  };
  return e.addEventListener("popstate", n), () => {
    e.removeEventListener("popstate", n);
  };
}
function Cn(t, e) {
  const n = P.get(t), r = n.sandBox.proxyWindow, o = n.sandBox.microAppWindow;
  let i = !1;
  const s = r.location.href;
  if (e) {
    const a = r.location.hash;
    Pe(t, e, o.location), i = r.location.hash !== a;
  }
  bo(t, r, o), i && Ro(t, r, o, s), B();
}
function bo(t, e, n) {
  const r = new PopStateEvent("popstate", { state: We(t) });
  n.dispatchEvent(r), $e(t) || y(e.onpopstate) && e.onpopstate(r);
}
function Ro(t, e, n, r) {
  const o = new HashChangeEvent("hashchange", {
    newURL: e.location.href,
    oldURL: r
  });
  n.dispatchEvent(o), $e(t) || y(e.onhashchange) && e.onhashchange(o);
}
function So(t) {
  const e = new PopStateEvent("popstate", { state: null });
  t && (e.onlyForBrowser = !0), l.rawWindow.dispatchEvent(e);
}
function yo(t) {
  const e = new HashChangeEvent("hashchange", {
    newURL: l.rawWindow.location.href,
    oldURL: t
  });
  l.rawWindow.dispatchEvent(e);
}
function lt(t, e, n) {
  B(), xe(t) && (So(e), n && yo(n));
}
function Ln(t, e) {
  const n = l.rawWindow.history;
  function r(s) {
    return function(...a) {
      var c, A, m;
      if (I(a[2]) || Ue(a[2])) {
        const v = x(a[2], e.href), b = v.pathname + v.search + v.hash;
        ge(t) || Ze(t, s, le(t, v), !0, Ne(t, a[0]), a[1]), b !== e.fullPath && Pe(t, b, e), (m = (c = P.get(t)) === null || c === void 0 ? void 0 : (A = c.sandBox).updateIframeBase) === null || m === void 0 || m.call(A);
      } else
        Oe(t, s, a[2], a[0], a[1]);
    };
  }
  const o = r("pushState"), i = r("replaceState");
  return $e(t) ? { pushState: o, replaceState: i } : new Proxy(n, {
    get(s, a) {
      return a === "state" ? We(t) : a === "pushState" ? o : a === "replaceState" ? i : Q(Reflect.get(s, a), s, "HISTORY");
    },
    set(s, a, c) {
      return Reflect.set(s, a, c), !0;
    }
  });
}
function Oe(t, e, n, r = null, o = "") {
  xe(t) && (e === "pushState" ? l.rawPushState : l.rawReplaceState).call(l.rawWindow.history, r, o, n);
}
function Ze(t, e, n, r, o, i) {
  if (xe(t)) {
    const s = l.rawWindow.location, a = s.pathname + s.search + s.hash, c = n.isAttach2Hash && a !== n.fullPath ? s.href : null;
    Oe(t, e, n.fullPath, o, i), a !== n.fullPath && J(t) && lt(t, r, c);
  }
}
function ke(t, e, n) {
  Ze(t, "replaceState", e, !0, n);
}
function Wt(t) {
  const e = l.rawWindow;
  return function(...n) {
    var r;
    if (!((r = e.history.state) === null || r === void 0) && r.microAppState && (!T(n[0]) || !n[0].microAppState) && (I(n[2]) || Ue(n[2]))) {
      const o = e.location.href;
      x(n[2], o).href === o && (n[0] = z({}, n[0], {
        microAppState: e.history.state.microAppState
      }));
    }
    t.apply(e.history, n), we({
      excludeHiddenApp: !0,
      excludePreRender: !0
    }).forEach((o) => {
      if (J(o) && !Fe(o)) {
        const i = P.get(o);
        ke(o, le(o, i.sandBox.proxyWindow.location), Ne(o, We(o)));
      }
    }), B();
  };
}
function In() {
  const t = l.rawWindow;
  t.history.pushState = Wt(l.rawPushState), t.history.replaceState = Wt(l.rawReplaceState);
}
function Nn() {
  const t = l.rawWindow;
  t.history.pushState = l.rawPushState, t.history.replaceState = l.rawReplaceState;
}
function Mo() {
  function t(g, S, _, p) {
    Ze(g, S, le(g, _), !1, Ne(g, p ?? null)), B();
  }
  function e(g, S, _, p) {
    const d = S.sandBox.proxyWindow.location, f = x(_.path, d.href), w = d.pathname + d.search + d.hash, u = f.pathname + f.search + f.hash;
    if (w !== u || Fe(g) !== u) {
      if (!ge(g)) {
        const h = p && _.replace !== !1 || _.replace === !0 ? "replaceState" : "pushState";
        t(g, h, f, _.state);
      }
      (he(g) || ge(g)) && Cn(g, u);
    }
  }
  function n(g) {
    return function(S) {
      return new Promise((_, p) => {
        const d = W(S.name);
        if (d && I(S.path))
          if (we({ excludeHiddenApp: !0, excludePreRender: !0 }).includes(d)) {
            const f = P.get(d);
            _(f.sandBox.sandboxReady.then(() => e(d, f, S, g)));
          } else
            p(O("navigation failed, app does not exist or is inactive"));
        else
          p(O(`navigation failed, name & path are required when use router.${g ? "replace" : "push"}`));
      });
    };
  }
  function r(g) {
    return function(...S) {
      return l.rawWindow.history[g](...S);
    };
  }
  const o = Ct(), i = Ct();
  function s(g, S, _, p) {
    B();
    for (const d of p)
      y(d) ? d(S, _, g) : T(d) && y(d[g]) && d[g](S, _);
  }
  function a(g, S, _) {
    D.current.set(g, S), s(g, S, _, o.list()), ze(() => {
      s(g, S, _, i.list());
    });
  }
  function c(g) {
    D.current.delete(g);
  }
  function A(g) {
    if (J(g)) {
      const S = P.get(g);
      ke(g, le(g, S.sandBox.proxyWindow.location), Ne(g, We(g)));
    }
  }
  function m(g) {
    g = W(g), g && we().includes(g) && A(g);
  }
  function v({ includeHiddenApp: g = !1, includePreRender: S = !1 }) {
    we({
      excludeHiddenApp: !g,
      excludePreRender: !S
    }).forEach((_) => A(_));
  }
  function b() {
    const g = yr();
    function S(p) {
      const d = W(p.name);
      return !d || !p.path ? (process.env.NODE_ENV !== "production" && Y(d ? "setDefaultPage: path is required" : `setDefaultPage: invalid appName "${d}"`), fr) : g.add(d, p.path);
    }
    function _(p) {
      return p = W(p), p ? g.delete(p) : !1;
    }
    return {
      setDefaultPage: S,
      removeDefaultPage: _,
      getDefaultPage: g.get
    };
  }
  function M() {
    let g = null;
    function S(_) {
      Xt(_) ? g = new Proxy(_, {
        get(p, d) {
          return B(), Q(Reflect.get(p, d), p, "BASEROUTER");
        },
        set(p, d, f) {
          return Reflect.set(p, d, f), !0;
        }
      }) : process.env.NODE_ENV !== "production" && Y("setBaseAppRouter: Invalid base router");
    }
    return {
      setBaseAppRouter: S,
      getBaseAppRouter: () => g
    };
  }
  const D = Object.assign(Object.assign({
    current: /* @__PURE__ */ new Map(),
    encode: Sn,
    decode: yn,
    push: n(!1),
    replace: n(!0),
    go: r("go"),
    back: r("back"),
    forward: r("forward"),
    beforeEach: o.add,
    afterEach: i.add,
    attachToURL: m,
    attachAllToURL: v
  }, b()), M());
  return {
    router: D,
    executeNavigationGuard: a,
    clearRouterWhenUnmount: c
  };
}
const { router: He, executeNavigationGuard: xn, clearRouterWhenUnmount: Oo } = Mo(), Do = [
  "getComputedStyle",
  "visualViewport",
  "matchMedia",
  // 'DOMParser',
  "ResizeObserver",
  "IntersectionObserver"
], Co = [
  /animationFrame$/i,
  /mutationObserver$/i,
  /height$|width$/i,
  /offset$/i,
  // /event$/i,
  /selection$/i,
  /^range/i,
  /^screen/i,
  /^scroll/i,
  /X$|Y$/
], Lo = [
  "body",
  "head",
  "html",
  "title"
], Io = [
  "host",
  "hostname",
  "port",
  "protocol",
  "origin"
], No = [
  "childElementCount",
  "children",
  "firstElementChild",
  "firstChild",
  "lastElementChild",
  "activeElement",
  "fullscreenElement",
  "pictureInPictureElement",
  "pointerLockElement",
  "styleSheets"
], xo = [
  "append",
  "contains",
  "replaceChildren",
  "createRange",
  "getSelection",
  "elementFromPoint",
  "elementsFromPoint",
  "getAnimations"
], To = [
  "characterSet",
  "compatMode",
  "contentType",
  "designMode",
  "dir",
  "doctype",
  "embeds",
  "fullscreenEnabled",
  "hidden",
  "implementation",
  "lastModified",
  "pictureInPictureEnabled",
  "plugins",
  "readyState",
  "referrer",
  "visibilityState",
  "fonts"
], Bo = [
  "execCommand",
  "createRange",
  "exitFullscreen",
  "exitPictureInPicture",
  "getElementsByTagNameNS",
  "hasFocus",
  "prepend"
], Uo = ["href", "pathname", "search", "hash", "host", "hostname", "port", "protocol", "search"], Wo = [...Uo, "origin", "fullPath"];
function Tn(t, e, n, r, o, i) {
  const a = l.rawWindow.location, c = !!n, A = x(e);
  function m() {
    return c ? n.location : A;
  }
  function v(p, d) {
    const f = x(p, _.href);
    if (f.origin === _.origin) {
      const w = le(t, f);
      if (J(t)) {
        if (f.pathname === _.pathname && f.search === _.search) {
          let u = null;
          f.hash !== _.hash && (w.isAttach2Hash && (u = a.href), Oe(t, d, w.fullPath)), f.hash ? lt(t, !1, u) : S();
          return;
        } else if (w.isAttach2Hash) {
          Oe(t, d, w.fullPath), S();
          return;
        }
      }
      return w.fullPath;
    }
    return p;
  }
  function b(p, d) {
    const f = x(p, e);
    f[d] === _[d] && _.hash ? lt(t, !1) : (Oe(t, f[d] === _[d] ? "replaceState" : "pushState", le(t, f).fullPath), S());
  }
  const M = (p) => function(d) {
    if (xe(t)) {
      const f = v(d, p === "assign" ? "pushState" : "replaceState");
      f && a[p](x(f, a.origin).href);
    }
  }, D = M("assign"), g = M("replace"), S = (p) => a.reload(p);
  F(m(), "fullPath", {
    enumerable: !0,
    configurable: !0,
    get: () => _.pathname + _.search + _.hash
  });
  const _ = new Proxy({}, {
    get: (p, d) => {
      const f = m();
      if (d === "assign")
        return D;
      if (d === "replace")
        return g;
      if (d === "reload")
        return S;
      if (d === "self")
        return f;
      if (d === "fullPath")
        return f.fullPath;
      if (Mn(t))
        return Q(Reflect.get(a, d), a, "LOCATION");
      if (c) {
        if (Io.includes(d))
          return r[d];
        if (d === "href")
          return f[d].replace(o, i);
      }
      return Q(Reflect.get(f, d), f, "LOCATION");
    },
    set: (p, d, f) => {
      if (xe(t)) {
        const w = m();
        if (d === "href") {
          const u = v(f, "pushState");
          u && (a.href = x(u, a.origin).href);
        } else if (d === "pathname")
          if (he(t))
            a.pathname = f;
          else {
            const u = ("/" + f).replace(/^\/+/, "/") + _.search + _.hash;
            b(u, "pathname");
          }
        else if (d === "search")
          if (he(t))
            a.search = f;
          else {
            const u = _.pathname + ("?" + f).replace(/^\?+/, "?") + _.hash;
            b(u, "search");
          }
        else if (d === "hash")
          if (he(t))
            a.hash = f;
          else {
            const u = _.pathname + _.search + ("#" + f).replace(/^#+/, "#"), h = x(u, e);
            h.hash !== _.hash && Ze(t, "pushState", le(t, h), !1);
          }
        else
          Reflect.set(w, d, f);
      }
      return !0;
    }
  });
  return _;
}
function Ve(t, e) {
  const n = z({ name: t }, e);
  for (const r of Wo)
    n[r] = e[r];
  return n;
}
function Fo(t, e) {
  xn(t, Ve(t, e), Ve(t, e));
}
function Pe(t, e, n, r) {
  var o;
  const i = Ve(t, n), s = x(e, n.href);
  if ($e(t)) {
    const c = P.get(t).sandBox.microAppWindow;
    (o = c.rawReplaceState) === null || o === void 0 || o.call(c.history, We(t), "", s.href);
  } else {
    let c = s.href;
    n.self.origin !== s.origin && (c = c.replace(s.origin, n.self.origin)), n.self.href = c;
  }
  const a = Ve(t, n);
  (r === "auto" || i.fullPath !== a.fullPath && r !== "prevent") && xn(t, a, i);
}
function Ho(t, e) {
  const n = Tn(t, e);
  return {
    microLocation: n,
    microHistory: Ln(t, n)
  };
}
function Bn(t, e, n) {
  const r = Fe(t);
  r ? Pe(t, r, e, "auto") : bt(t, e, n);
}
function bt(t, e, n) {
  n && Pe(t, n, e, "prevent"), ge(t) || ke(t, le(t, e), Ne(t, null)), Fo(t, e);
}
function Un(t, e, n, r) {
  if (!he(t)) {
    if (!r) {
      const { pathname: o, search: i, hash: s } = x(e);
      Pe(t, o + i + s, n, "prevent");
    }
    ge(t) || Rt(t);
  }
  Oo(t);
}
function Rt(t) {
  ke(t, vo(t), Eo(t, l.rawWindow.history.state));
}
class $o {
  constructor() {
    this.rawWindowScopeKeyList = [
      "location"
    ], this.staticEscapeProperties = [
      "System",
      "__cjsWrapper"
    ], this.staticScopeProperties = [
      "webpackJsonp",
      "webpackHotUpdate",
      "Vue",
      // TODO: 是否可以和constants/SCOPE_WINDOW_ON_EVENT合并
      "onpopstate",
      "onhashchange"
    ], this.scopeProperties = Array.from(this.staticScopeProperties), this.escapeProperties = [], this.injectedKeys = /* @__PURE__ */ new Set(), this.escapeKeys = /* @__PURE__ */ new Set(), this.injectReactHMRProperty();
  }
  // adapter for react
  injectReactHMRProperty() {
    process.env.NODE_ENV !== "production" && (this.staticEscapeProperties.push("__REACT_ERROR_OVERLAY_GLOBAL_HOOK__"), l.rawWindow.__REACT_ERROR_OVERLAY_GLOBAL_HOOK__ && (this.staticScopeProperties = this.staticScopeProperties.concat([
      "__REACT_ERROR_OVERLAY_GLOBAL_HOOK__",
      "__reactRefreshInjected"
    ])));
  }
}
class jo {
}
function Go() {
  l.rawWindow._babelPolyfill && (l.rawWindow._babelPolyfill = !1);
}
function Ko(t) {
  var e;
  if (process.env.NODE_ENV !== "production") {
    const n = l.rawWindow.__REACT_ERROR_OVERLAY_GLOBAL_HOOK__, r = (e = t.sandBox) === null || e === void 0 ? void 0 : e.proxyWindow.__REACT_ERROR_OVERLAY_GLOBAL_HOOK__;
    n && r && (l.rawWindow.__REACT_ERROR_OVERLAY_GLOBAL_HOOK__ = r, X(() => {
      l.rawWindow.__REACT_ERROR_OVERLAY_GLOBAL_HOOK__ = n;
    }));
  }
}
function St(t, e) {
  const n = Array.from(t.children);
  n.length && n.forEach((r) => {
    St(r, e);
  });
  for (const r of n)
    $(r, e);
}
function $(t, e) {
  var n, r;
  const o = (r = (n = P.get(e)) === null || n === void 0 ? void 0 : n.sandBox) === null || r === void 0 ? void 0 : r.proxyWindow;
  return ve(t) && !t.__MICRO_APP_NAME__ && !t.__PURE_ELEMENT__ && o && ie(t, {
    baseURI: {
      configurable: !0,
      // if disable-memory-router or router-mode='disable', href point to base app
      get: () => o.location.href
    },
    __MICRO_APP_NAME__: {
      configurable: !0,
      writable: !0,
      value: e
    }
  }), t;
}
function Ft(t, e) {
  const n = de(e) ? l.rawWindow.fetch : e;
  return y(n) ? function(o, i, ...s) {
    return (I(o) || Ue(o)) && (o = x(o, t).toString()), B(), n.call(l.rawWindow, o, i, ...s);
  } : n;
}
function Ht(t, e) {
  const n = de(e) ? l.rawWindow.XMLHttpRequest : e;
  return ht(n) ? class extends n {
    open(o, i, ...s) {
      (I(i) && !/^f(ile|tp):\/\//.test(i) || Ue(i)) && (i = x(i, t).toString()), B(), super.open(o, i, ...s);
    }
  } : n;
}
function qo() {
  let t;
  function e(r, o, i) {
    const s = de(i) ? l.rawWindow.EventSource : i;
    return ht(s) ? class extends s {
      constructor(c, A, ...m) {
        if ((I(c) || Ue(c)) && (c = x(c, o).toString()), B(), super(c, A, ...m), t) {
          const v = t.get(r);
          v ? v.add(this) : t.set(r, /* @__PURE__ */ new Set([this]));
        } else
          t = /* @__PURE__ */ new Map([[r, /* @__PURE__ */ new Set([this])]]);
      }
      close() {
        var c;
        super.close(), (c = t.get(r)) === null || c === void 0 || c.delete(this);
      }
    } : s;
  }
  function n(r) {
    const o = t == null ? void 0 : t.get(r);
    o != null && o.size && (o.forEach((i) => {
      i.close();
    }), o.clear());
  }
  return {
    createMicroEventSource: e,
    clearMicroEventSource: n
  };
}
const { createMicroEventSource: $t, clearMicroEventSource: Qo } = qo();
class Te extends $o {
  constructor(e, n) {
    super(), this.active = !1, this.microAppWindow = new jo(), this.patchWith((r) => {
      this.getSpecialProperties(e), this.patchRouter(e, n, this.microAppWindow), this.windowEffect = fo(e, this.microAppWindow, this), this.documentEffect = lo(e, this.microAppWindow, this), this.setMappingPropertiesWithRawDescriptor(this.microAppWindow), this.initStaticGlobalKeys(e, n, this.microAppWindow), r();
    });
  }
  /**
   * open sandbox and perform some initial actions
   * @param umdMode is umd mode
   * @param baseroute base route for child
   * @param defaultPage default page when mount child base on virtual router
   * @param disablePatchRequest prevent patchRequestApi
   */
  start({ umdMode: e, baseroute: n, defaultPage: r, disablePatchRequest: o }) {
    this.active || (this.active = !0, this.initRouteState(r), this.removeHistoryListener = Dn(this.microAppWindow.__MICRO_APP_NAME__), he(this.microAppWindow.__MICRO_APP_NAME__) && (this.microAppWindow.__MICRO_APP_BASE_ROUTE__ = this.microAppWindow.__MICRO_APP_BASE_URL__ = n), e || this.initGlobalKeysWhenStart(this.microAppWindow.__MICRO_APP_NAME__, this.microAppWindow.__MICRO_APP_URL__, this.microAppWindow, o), ++l.activeSandbox === 1 && (Gn(), In()), ++Te.activeCount === 1 && so(), Go());
  }
  /**
   * close sandbox and perform some clean up actions
   * @param umdMode is umd mode
   * @param keepRouteState prevent reset route
   * @param destroy completely destroy, delete cache resources
   * @param clearData clear data from base app
   */
  stop({ umdMode: e, keepRouteState: n, destroy: r, clearData: o }) {
    var i;
    this.active && (this.recordAndReleaseEffect({ umdMode: e, clearData: o, destroy: r }, !e || r), this.clearRouteState(n), (i = this.removeHistoryListener) === null || i === void 0 || i.call(this), (!e || r) && (Qo(this.microAppWindow.__MICRO_APP_NAME__), this.injectedKeys.forEach((s) => {
      Reflect.deleteProperty(this.microAppWindow, s);
    }), this.injectedKeys.clear(), this.escapeKeys.forEach((s) => {
      Reflect.deleteProperty(l.rawWindow, s);
    }), this.escapeKeys.clear()), --l.activeSandbox === 0 && (Kn(), Nn()), --Te.activeCount, this.active = !1);
  }
  /**
   * inject global properties to microAppWindow
   * TODO: 设置为只读变量
   * @param appName app name
   * @param url app url
   * @param microAppWindow micro window
   */
  initStaticGlobalKeys(e, n, r) {
    r.__MICRO_APP_ENVIRONMENT__ = !0, r.__MICRO_APP_NAME__ = e, r.__MICRO_APP_URL__ = n, r.__MICRO_APP_PUBLIC_PATH__ = Xe(n), r.__MICRO_APP_BASE_ROUTE__ = "", r.__MICRO_APP_WINDOW__ = r, r.__MICRO_APP_PRE_RENDER__ = !1, r.__MICRO_APP_UMD_MODE__ = !1, r.__MICRO_APP_PROXY_WINDOW__ = this.proxyWindow, r.__MICRO_APP_SANDBOX__ = this, r.__MICRO_APP_SANDBOX_TYPE__ = "with", r.rawWindow = l.rawWindow, r.rawDocument = l.rawDocument, r.microApp = z(new An(e), {
      removeDomScope: B,
      pureCreateElement: K,
      router: He
    });
  }
  /**
   * Record global effect and then release (effect: global event, timeout, data listener)
   * Scenes:
   * 1. unmount of default/umd app
   * 2. hidden keep-alive app
   * 3. after init prerender app
   * @param options {
   *  @param clearData clear data from base app
   *  @param isPrerender is prerender app
   *  @param keepAlive is keep-alive app
   * }
   * @param preventRecord prevent record effect events
   */
  recordAndReleaseEffect(e, n = !1) {
    n ? this.resetEffectSnapshot() : this.recordEffectSnapshot(), this.releaseGlobalEffect(e);
  }
  /**
   * reset effect snapshot data in default mode or destroy
   * Scenes:
   *  1. unmount hidden keep-alive app manually
   *  2. unmount prerender app manually
   */
  resetEffectSnapshot() {
    this.windowEffect.reset(), this.documentEffect.reset(), vt(this.microAppWindow.microApp);
  }
  /**
   * record umd snapshot before the first execution of umdHookMount
   * Scenes:
   * 1. exec umdMountHook in umd mode
   * 2. hidden keep-alive app
   * 3. after init prerender app
   */
  recordEffectSnapshot() {
    this.windowEffect.record(), this.documentEffect.record(), wn(this.microAppWindow.microApp);
  }
  // rebuild umd snapshot before remount umd app
  rebuildEffectSnapshot() {
    this.windowEffect.rebuild(), this.documentEffect.rebuild(), vn(this.microAppWindow.microApp);
  }
  /**
   * clear global event, timeout, data listener
   * Scenes:
   * 1. unmount of default/umd app
   * 2. hidden keep-alive app
   * 3. after init prerender app
   * @param umdMode is umd mode
   * @param clearData clear data from base app
   * @param isPrerender is prerender app
   * @param keepAlive is keep-alive app
   * @param destroy completely destroy
   */
  releaseGlobalEffect({ umdMode: e = !1, clearData: n = !1, isPrerender: r = !1, keepAlive: o = !1, destroy: i = !1 }) {
    var s, a, c;
    this.windowEffect.release(!e && !o && !r || i), this.documentEffect.release(), (s = this.microAppWindow.microApp) === null || s === void 0 || s.clearDataListener(), (a = this.microAppWindow.microApp) === null || a === void 0 || a.clearGlobalDataListener(), n && (R.clearData(this.microAppWindow.__MICRO_APP_NAME__), (c = this.microAppWindow.microApp) === null || c === void 0 || c.clearData());
  }
  /**
   * get scopeProperties and escapeProperties from plugins & adapter
   * @param appName app name
   */
  getSpecialProperties(e) {
    var n;
    T(R.options.plugins) && (this.commonActionForSpecialProperties(R.options.plugins.global), this.commonActionForSpecialProperties((n = R.options.plugins.modules) === null || n === void 0 ? void 0 : n[e]));
  }
  // common action for global plugins and module plugins
  commonActionForSpecialProperties(e) {
    if (ee(e))
      for (const n of e)
        T(n) && (ee(n.scopeProperties) && (this.scopeProperties = this.scopeProperties.concat(n.scopeProperties)), ee(n.escapeProperties) && (this.escapeProperties = this.escapeProperties.concat(n.escapeProperties)));
  }
  // set __MICRO_APP_PRE_RENDER__ state
  setPreRenderState(e) {
    this.microAppWindow.__MICRO_APP_PRE_RENDER__ = e;
  }
  markUmdMode(e) {
    this.microAppWindow.__MICRO_APP_UMD_MODE__ = e;
  }
  patchWith(e) {
    this.sandboxReady = new Promise((n) => e(n));
  }
  // properties associated with the native window
  setMappingPropertiesWithRawDescriptor(e) {
    let n, r;
    const o = l.rawWindow;
    o === o.parent ? n = r = this.proxyWindow : (n = o.top, r = o.parent), ie(e, {
      top: this.createDescriptorForMicroAppWindow("top", n),
      parent: this.createDescriptorForMicroAppWindow("parent", r)
    }), an.forEach((i) => {
      F(e, i, this.createDescriptorForMicroAppWindow(i, this.proxyWindow));
    });
  }
  createDescriptorForMicroAppWindow(e, n) {
    const { configurable: r = !0, enumerable: o = !0, writable: i, set: s } = Object.getOwnPropertyDescriptor(l.rawWindow, e) || { writable: !0 };
    return {
      value: n,
      configurable: r,
      enumerable: o,
      writable: i ?? !!s
    };
  }
  /**
   * init global properties of microAppWindow when exec sandBox.start
   * @param microAppWindow micro window
   * @param appName app name
   * @param url app url
   * @param disablePatchRequest prevent rewrite request method of child app
   */
  initGlobalKeysWhenStart(e, n, r, o) {
    r.hasOwnProperty = (i) => ue.call(r, i) || ue.call(l.rawWindow, i), this.setHijackProperty(e, r), o || this.patchRequestApi(e, n, r), this.setScopeProperties(r);
  }
  // set hijack Properties to microAppWindow
  setHijackProperty(e, n) {
    let r, o;
    ie(n, {
      eval: {
        configurable: !0,
        enumerable: !1,
        get() {
          return fe(e), r || l.rawWindow.eval;
        },
        set: (i) => {
          r = i;
        }
      },
      Image: {
        configurable: !0,
        enumerable: !1,
        get() {
          return fe(e), o || l.ImageProxy;
        },
        set: (i) => {
          o = i;
        }
      }
    });
  }
  // rewrite fetch, XMLHttpRequest, EventSource
  patchRequestApi(e, n, r) {
    let o = Ft(n), i = Ht(n), s = $t(e, n);
    ie(r, {
      fetch: {
        configurable: !0,
        enumerable: !0,
        get() {
          return o;
        },
        set(a) {
          o = Ft(n, a);
        }
      },
      XMLHttpRequest: {
        configurable: !0,
        enumerable: !0,
        get() {
          return i;
        },
        set(a) {
          i = Ht(n, a);
        }
      },
      EventSource: {
        configurable: !0,
        enumerable: !0,
        get() {
          return s;
        },
        set(a) {
          s = $t(e, n, a);
        }
      }
    });
  }
  /**
   * Init scope keys to microAppWindow, prevent fall to rawWindow from with(microAppWindow)
   * like: if (!xxx) {}
   * NOTE:
   * 1. Symbol.unscopables cannot affect undefined keys
   * 2. Doesn't use for window.xxx because it fall to proxyWindow
   */
  setScopeProperties(e) {
    this.scopeProperties.forEach((n) => {
      Reflect.set(e, n, e[n]);
    });
  }
  // set location & history for memory router
  patchRouter(e, n, r) {
    const { microLocation: o, microHistory: i } = Ho(e, n);
    ie(r, {
      location: {
        configurable: !1,
        enumerable: !0,
        get() {
          return o;
        },
        set: (s) => {
          l.rawWindow.location = s;
        }
      },
      history: {
        configurable: !0,
        enumerable: !0,
        get() {
          return i;
        }
      }
    });
  }
  initRouteState(e) {
    Bn(this.microAppWindow.__MICRO_APP_NAME__, this.microAppWindow.location, e);
  }
  clearRouteState(e) {
    Un(this.microAppWindow.__MICRO_APP_NAME__, this.microAppWindow.__MICRO_APP_URL__, this.microAppWindow.location, e);
  }
  setRouteInfoForKeepAliveApp() {
    bt(this.microAppWindow.__MICRO_APP_NAME__, this.microAppWindow.location);
  }
  removeRouteInfoForKeepAliveApp() {
    Rt(this.microAppWindow.__MICRO_APP_NAME__);
  }
  /**
   * Format all html elements when init
   * @param container micro app container
   */
  patchStaticElement(e) {
    St(e, this.microAppWindow.__MICRO_APP_NAME__);
  }
  /**
   * action before exec scripts when mount
   * Actions:
   * 1. patch static elements from html
   * @param container micro app container
   */
  actionBeforeExecScripts(e) {
    this.patchStaticElement(e);
  }
  setStaticAppState(e) {
    this.microAppWindow.__MICRO_APP_STATE__ = e;
  }
}
Te.activeCount = 0;
function Vo(t, e, n, r) {
  const o = x(e), i = o.protocol + "//" + o.host, s = o.pathname + o.search + o.hash, a = n.history;
  return n.rawReplaceState = a.replaceState, z(a, Ln(t, n.location)), Pe(t, s, n.location, "prevent"), Tn(t, e, n, o, r, i);
}
function Xo(t, e, n) {
  return Yo(t, e), zo(e, n), Jo(e);
}
function Yo(t, e) {
  const n = l.rawWindow;
  Do.forEach((r) => {
    e[r] = Q(n[r], n);
  }), Object.getOwnPropertyNames(e).filter((r) => (Co.some((o) => {
    if (o.test(r) && r in e.parent) {
      if (y(n[r]))
        e[r] = Q(n[r], n);
      else {
        const { configurable: i, enumerable: s } = Object.getOwnPropertyDescriptor(e, r) || {
          configurable: !0,
          enumerable: !0
        };
        i && F(e, r, {
          configurable: i,
          enumerable: s,
          get: () => n[r],
          set: (a) => {
            n[r] = a;
          }
        });
      }
      return !0;
    }
    return !1;
  }), /^on/.test(r) && !sn.includes(r))).forEach((r) => {
    const { enumerable: o, writable: i, set: s } = Object.getOwnPropertyDescriptor(e, r) || {
      enumerable: !0,
      writable: !0
    };
    try {
      F(e, r, {
        enumerable: o,
        configurable: !0,
        get: () => n[r],
        set: i ?? !!s ? (a) => {
          n[r] = y(a) ? a.bind(e) : a;
        } : void 0
      });
    } catch (a) {
      Y(a, t);
    }
  });
}
function zo(t, e) {
  const n = l.rawWindow, r = /* @__PURE__ */ new Set(), o = new Proxy(t, {
    get: (i, s) => s === "location" ? e.proxyLocation : V(an, s) ? o : r.has(s) ? Reflect.get(i, s) : V(e.escapeProperties, s) && !Reflect.has(i, s) ? Q(Reflect.get(n, s), n) : Q(Reflect.get(i, s), i),
    set: (i, s, a) => s === "location" ? Reflect.set(n, s, a) : (Reflect.has(i, s) || r.add(s), Reflect.set(i, s, a), V(e.escapeProperties, s) && (!Reflect.has(n, s) && e.escapeKeys.add(s), Reflect.set(n, s, a)), !0),
    has: (i, s) => s in i,
    deleteProperty: (i, s) => Reflect.has(i, s) ? (e.escapeKeys.has(s) && Reflect.deleteProperty(n, s), Reflect.deleteProperty(i, s)) : !0
  });
  e.proxyWindow = o;
}
function Jo(t) {
  const { rawWindow: e, rawAddEventListener: n, rawRemoveEventListener: r } = l, o = /* @__PURE__ */ new Map(), i = /* @__PURE__ */ new Map();
  function s(v) {
    return on.includes(v) ? t : e;
  }
  t.addEventListener = function(v, b, M) {
    const D = o.get(v);
    D ? D.add(b) : o.set(v, /* @__PURE__ */ new Set([b])), b && (b.__MICRO_APP_MARK_OPTIONS__ = M), n.call(s(v), v, b, M);
  }, t.removeEventListener = function(v, b, M) {
    const D = o.get(v);
    D != null && D.size && D.has(b) && D.delete(b), r.call(s(v), v, b, M);
  };
  const a = () => {
    i.clear();
  };
  return {
    reset: a,
    record: () => {
      o.forEach((v, b) => {
        if (v.size) {
          const M = i.get(b) || [];
          i.set(b, /* @__PURE__ */ new Set([...M, ...v]));
        }
      });
    },
    rebuild: () => {
      i.forEach((v, b) => {
        for (const M of v)
          t.addEventListener(b, M, M == null ? void 0 : M.__MICRO_APP_MARK_OPTIONS__);
      }), a();
    },
    release: () => {
      o.size && (o.forEach((v, b) => {
        for (const M of v)
          r.call(s(b), b, M);
      }), o.clear());
    }
  };
}
function Zo(t, e, n) {
  return ko(t, e), ei(t, e, n), ti(t, e);
}
function ko(t, e) {
  const n = l.rawDocument, r = e.Document, o = e.document, i = r.prototype.createElement, s = r.prototype.createElementNS, a = r.prototype.createTextNode, c = r.prototype.createDocumentFragment, A = r.prototype.createComment, m = r.prototype.querySelector, v = r.prototype.querySelectorAll, b = r.prototype.getElementById, M = r.prototype.getElementsByClassName, D = r.prototype.getElementsByTagName, g = r.prototype.getElementsByName, S = r.prototype.elementFromPoint, _ = r.prototype.caretRangeFromPoint;
  r.prototype.caretRangeFromPoint = function(u, h) {
    const E = S.call(n, u, h), L = _.call(n, u, h);
    return $(E, t), L;
  }, r.prototype.createElement = function(u, h) {
    const E = i.call(this, u, h);
    return $(E, t);
  }, r.prototype.createElementNS = function(u, h, E) {
    const L = s.call(this, u, h, E);
    return $(L, t);
  }, r.prototype.createTextNode = function(u) {
    const h = a.call(this, u);
    return $(h, t);
  }, r.prototype.createDocumentFragment = function() {
    const u = c.call(this);
    return $(u, t);
  }, r.prototype.createComment = function(u) {
    const h = A.call(this, u);
    return $(h, t);
  };
  function p(w) {
    return o !== w ? w : n;
  }
  function d(w) {
    var u, h;
    if (!w || Ae(w) || o !== this) {
      const E = p(this);
      return m.call(E, w);
    }
    return (h = (u = P.get(t)) === null || u === void 0 ? void 0 : u.querySelector(w)) !== null && h !== void 0 ? h : null;
  }
  function f(w) {
    var u, h;
    if (!w || Ae(w) || o !== this) {
      const E = p(this);
      return v.call(E, w);
    }
    return (h = (u = P.get(t)) === null || u === void 0 ? void 0 : u.querySelectorAll(w)) !== null && h !== void 0 ? h : [];
  }
  r.prototype.querySelector = d, r.prototype.querySelectorAll = f, r.prototype.getElementById = function(u) {
    const h = p(this);
    if (se(u))
      return b.call(h, u);
    try {
      return d.call(this, `#${u}`);
    } catch {
      return b.call(h, u);
    }
  }, r.prototype.getElementsByClassName = function(u) {
    const h = p(this);
    if (se(u))
      return M.call(h, u);
    try {
      return f.call(this, `.${u}`);
    } catch {
      return M.call(h, u);
    }
  }, r.prototype.getElementsByTagName = function(u) {
    const h = p(this);
    if (Ae(u) || se(u))
      return D.call(h, u);
    if (/^script|base$/i.test(u))
      return D.call(o, u);
    try {
      return f.call(this, u);
    } catch {
      return D.call(h, u);
    }
  }, r.prototype.getElementsByName = function(u) {
    const h = p(this);
    if (se(u))
      return g.call(h, u);
    try {
      return f.call(this, `[name=${u}]`);
    } catch {
      return g.call(h, u);
    }
  };
}
function ei(t, e, n) {
  const r = l.rawDocument, o = e.Document, i = e.document, s = (c, A) => {
    const { enumerable: m } = Object.getOwnPropertyDescriptor(o.prototype, c) || {
      enumerable: !0
    };
    return {
      configurable: !0,
      enumerable: m,
      get: A
    };
  }, a = () => {
    const c = {};
    return [
      // if disable-memory-router or router-mode='disable', href point to base app
      ["documentURI", () => n.proxyLocation.href],
      ["URL", () => n.proxyLocation.href],
      ["documentElement", () => r.documentElement],
      ["scrollingElement", () => r.scrollingElement],
      ["forms", () => o.prototype.querySelectorAll.call(i, "form")],
      ["images", () => o.prototype.querySelectorAll.call(i, "img")],
      ["links", () => o.prototype.querySelectorAll.call(i, "a")],
      // unique keys of micro-app
      ["microAppElement", () => {
        var m;
        return (m = P.get(t)) === null || m === void 0 ? void 0 : m.container;
      }],
      ["__MICRO_APP_NAME__", () => t]
    ].forEach((m) => {
      c[m[0]] = s(m[0], m[1]);
    }), No.forEach((m) => {
      c[m] = s(m, () => r[m]);
    }), xo.forEach((m) => {
      c[m] = s(m, () => Q(r[m], r, "DOCUMENT"));
    }), To.forEach((m) => {
      c[m] = s(m, () => r[m]);
    }), Bo.forEach((m) => {
      c[m] = s(m, () => Q(r[m], r, "DOCUMENT"));
    }), c;
  };
  ie(o.prototype, a()), Lo.forEach((c) => {
    F(i, c, {
      enumerable: !0,
      configurable: !0,
      get: () => (fe(t), r[c]),
      set: (A) => {
        r[c] = A;
      }
    });
  });
}
function ti(t, e) {
  const { rawDocument: n, rawAddEventListener: r, rawRemoveEventListener: o } = l, i = /* @__PURE__ */ new Map(), s = /* @__PURE__ */ new Map();
  let a = null, c = null;
  const A = e.Document, m = e.document;
  function v(_, p) {
    return Fr.includes(_) ? p : n;
  }
  A.prototype.addEventListener = function(_, p, d) {
    const f = y(p) ? p.__MICRO_APP_BOUND_FUNCTION__ = p.__MICRO_APP_BOUND_FUNCTION__ || p.bind(this) : p, w = i.get(_);
    w ? w.add(p) : i.set(_, /* @__PURE__ */ new Set([p])), p && (p.__MICRO_APP_MARK_OPTIONS__ = d), r.call(v(_, this), _, f, d);
  }, A.prototype.removeEventListener = function(_, p, d) {
    const f = i.get(_);
    f != null && f.size && f.has(p) && f.delete(p);
    const w = (p == null ? void 0 : p.__MICRO_APP_BOUND_FUNCTION__) || p;
    o.call(v(_, this), _, w, d);
  };
  function b(_) {
    return _ === "onclick" ? (p) => {
      y(a) && o.call(n, "click", a, !1), y(p) ? (a = p.bind(m), r.call(n, "click", a, !1)) : a = p;
    } : (p) => {
      n[_] = y(p) ? p.bind(m) : p;
    };
  }
  Object.getOwnPropertyNames(A.prototype).filter((_) => /^on/.test(_) && !Hr.includes(_)).forEach((_) => {
    const { enumerable: p, writable: d, set: f } = Object.getOwnPropertyDescriptor(A.prototype, _) || {
      enumerable: !0,
      writable: !0
    };
    try {
      F(A.prototype, _, {
        enumerable: p,
        configurable: !0,
        get: () => _ === "onclick" ? a : n[_],
        set: d ?? !!f ? b(_) : void 0
      });
    } catch (w) {
      Y(w, t);
    }
  });
  const M = () => {
    s.clear(), c = null;
  };
  return {
    reset: M,
    record: () => {
      c = a || c, i.forEach((_, p) => {
        if (_.size) {
          const d = s.get(p) || [];
          s.set(p, /* @__PURE__ */ new Set([...d, ..._]));
        }
      });
    },
    rebuild: () => {
      c && !a && (m.onclick = c), s.forEach((_, p) => {
        for (const d of _)
          m.addEventListener(p, d, d == null ? void 0 : d.__MICRO_APP_MARK_OPTIONS__);
      }), M();
    },
    release: () => {
      y(a) && o.call(n, "click", a), a = null, i.size && (i.forEach((_, p) => {
        for (const d of _)
          o.call(v(p, m), p, (d == null ? void 0 : d.__MICRO_APP_BOUND_FUNCTION__) || d);
      }), i.clear());
    }
  };
}
function ni(t, e, n, r) {
  ri(t, n, r), oi(e, n);
}
function ri(t, e, n) {
  const r = l.rawRootElement, o = l.rawDocument, i = e.document, s = e.Node, a = e.Element, c = s.prototype.appendChild, A = s.prototype.insertBefore, m = s.prototype.replaceChild, v = s.prototype.removeChild, b = a.prototype.append, M = a.prototype.prepend, D = a.prototype.insertAdjacentElement, g = s.prototype.cloneNode, S = Object.getOwnPropertyDescriptor(a.prototype, "innerHTML"), _ = Object.getOwnPropertyDescriptor(s.prototype, "parentNode"), p = Object.getOwnPropertyDescriptor(s.prototype, "ownerDocument"), d = (u) => (Ee(u) || vr(u)) && u.__PURE_ELEMENT__, f = (u) => u === n.microHead ? o.head : u === n.microBody ? o.body : u;
  s.prototype.getRootNode = function() {
    return i;
  }, s.prototype.appendChild = function(h) {
    return $(h, t), d(h) ? c.call(this, h) : r.prototype.appendChild.call(f(this), h);
  }, s.prototype.insertBefore = function(h, E) {
    return $(h, t), d(h) ? A.call(this, h, E) : r.prototype.insertBefore.call(f(this), h, E);
  }, s.prototype.replaceChild = function(h, E) {
    return $(h, t), d(h) ? m.call(this, h, E) : r.prototype.replaceChild.call(f(this), h, E);
  }, s.prototype.removeChild = function(h) {
    return d(h) || this.contains(h) ? v.call(this, h) : r.prototype.removeChild.call(f(this), h);
  }, a.prototype.append = function(...h) {
    let E = 0, L = !1;
    for (; E < h.length; )
      h[E] = ve(h[E]) ? h[E] : i.createTextNode(h[E]), d(h[E]) && (L = !0), E++;
    return L ? b.call(this, ...h) : r.prototype.append.call(f(this), ...h);
  }, a.prototype.prepend = function(...h) {
    let E = 0, L = !1;
    for (; E < h.length; )
      h[E] = ve(h[E]) ? h[E] : i.createTextNode(h[E]), d(h[E]) && (L = !0), E++;
    return L ? M.call(this, ...h) : r.prototype.prepend.call(f(this), ...h);
  }, a.prototype.insertAdjacentElement = function(h, E) {
    return $(E, t), d(E) ? D.call(this, h, E) : r.prototype.insertAdjacentElement.call(f(this), h, E);
  }, s.prototype.cloneNode = function(h) {
    const E = g.call(this, h);
    return $(E, t);
  }, F(s.prototype, "ownerDocument", {
    configurable: !0,
    enumerable: !0,
    get() {
      return this.__PURE_ELEMENT__ ? p.get.call(this) : i;
    }
  }), F(a.prototype, "innerHTML", {
    configurable: !0,
    enumerable: !0,
    get() {
      return S.get.call(this);
    },
    set(u) {
      S.set.call(this, u), Array.from(this.children).forEach((h) => {
        ae(h) && $(h, t);
      });
    }
  }), F(s.prototype, "parentNode", {
    configurable: !0,
    enumerable: !0,
    get() {
      var u, h, E;
      fe(t);
      const L = _.get.call(this);
      return it(L) && (!((u = P.get(t)) === null || u === void 0) && u.container) ? ((E = (h = R.options).getRootElementParentNode) === null || E === void 0 ? void 0 : E.call(h, this, t)) || l.rawDocument.body : L;
    }
  });
  const w = new Proxy(e.Image, {
    construct(u, h) {
      const E = new u(...h);
      return $(E, t), E;
    }
  });
  F(e, "Image", {
    configurable: !0,
    writable: !0,
    value: w
  });
}
function oi(t, e) {
  const n = e.Element, r = n.prototype.setAttribute;
  n.prototype.setAttribute = function(s, a) {
    ((s === "src" || s === "srcset") && /^(img|script)$/i.test(this.tagName) || s === "href" && /^link$/i.test(this.tagName)) && (a = G(a, t)), r.call(this, s, a);
  }, [
    [e.HTMLImageElement.prototype, "src"],
    [e.HTMLScriptElement.prototype, "src"],
    [e.HTMLLinkElement.prototype, "href"]
  ].forEach(([i, s]) => {
    const { enumerable: a, configurable: c, get: A, set: m } = Object.getOwnPropertyDescriptor(i, s) || {
      enumerable: !0,
      configurable: !0
    };
    F(i, s, {
      enumerable: a,
      configurable: c,
      get: function() {
        return A == null ? void 0 : A.call(this);
      },
      set: function(v) {
        m == null || m.call(this, G(v, t));
      }
    });
  });
}
class Be {
  constructor(e, n) {
    this.active = !1, this.escapeProperties = [], this.escapeKeys = /* @__PURE__ */ new Set(), this.updateIframeBase = () => {
      var i;
      (i = this.baseElement) === null || i === void 0 || i.setAttribute("href", x(this.url).origin + this.proxyLocation.pathname);
    }, this.appName = e, this.url = n;
    const r = l.rawWindow.location, o = r.protocol + "//" + r.host;
    this.deleteIframeElement = this.createIframeElement(e, o + r.pathname), this.microAppWindow = this.iframe.contentWindow, this.patchIframe(this.microAppWindow, (i) => {
      this.createIframeTemplate(this.microAppWindow), this.getSpecialProperties(e), this.proxyLocation = Vo(e, n, this.microAppWindow, o), this.windowEffect = Xo(e, this.microAppWindow, this), this.documentEffect = Zo(e, this.microAppWindow, this), ni(e, n, this.microAppWindow, this), this.initStaticGlobalKeys(e, n, this.microAppWindow), i();
    });
  }
  /**
   * create iframe for sandbox
   * @param appName app name
   * @param browserPath browser origin
   * @returns release callback
   */
  createIframeElement(e, n) {
    this.iframe = K("iframe");
    const r = {
      src: R.options.iframeSrc || n,
      style: "display: none",
      id: e
    };
    return Object.keys(r).forEach((o) => this.iframe.setAttribute(o, r[o])), l.rawDocument.body.appendChild(this.iframe), () => X(() => {
      var o, i;
      (i = (o = this.iframe) === null || o === void 0 ? void 0 : o.parentNode) === null || i === void 0 || i.removeChild(this.iframe), this.iframe = null;
    });
  }
  start({ baseroute: e, defaultPage: n, disablePatchRequest: r }) {
    this.active || (this.active = !0, this.initRouteState(n), this.removeHistoryListener = Dn(this.microAppWindow.__MICRO_APP_NAME__), he(this.microAppWindow.__MICRO_APP_NAME__) && (this.microAppWindow.__MICRO_APP_BASE_ROUTE__ = this.microAppWindow.__MICRO_APP_BASE_URL__ = e), r || this.createIframeBase(), ++l.activeSandbox === 1 && (Gn(), In()), ++Be.activeCount);
  }
  stop({ umdMode: e, keepRouteState: n, destroy: r, clearData: o }) {
    var i;
    this.active && (this.recordAndReleaseEffect({ clearData: o }, !e || r), this.clearRouteState(n), (i = this.removeHistoryListener) === null || i === void 0 || i.call(this), (!e || r) && (this.deleteIframeElement(), this.escapeKeys.forEach((s) => {
      Reflect.deleteProperty(l.rawWindow, s);
    }), this.escapeKeys.clear()), --l.activeSandbox === 0 && (Kn(), Nn()), --Be.activeCount, this.active = !1);
  }
  /**
   * create static properties
   * NOTE:
   *  1. execute as early as possible
   *  2. run after patchRouter & createProxyWindow
   * TODO: 设置为只读变量
   */
  initStaticGlobalKeys(e, n, r) {
    r.__MICRO_APP_ENVIRONMENT__ = !0, r.__MICRO_APP_NAME__ = e, r.__MICRO_APP_URL__ = n, r.__MICRO_APP_PUBLIC_PATH__ = Xe(n), r.__MICRO_APP_BASE_ROUTE__ = "", r.__MICRO_APP_WINDOW__ = r, r.__MICRO_APP_PRE_RENDER__ = !1, r.__MICRO_APP_UMD_MODE__ = !1, r.__MICRO_APP_PROXY_WINDOW__ = this.proxyWindow, r.__MICRO_APP_SANDBOX__ = this, r.__MICRO_APP_SANDBOX_TYPE__ = "iframe", r.rawWindow = l.rawWindow, r.rawDocument = l.rawDocument, r.microApp = z(new An(e), {
      removeDomScope: B,
      pureCreateElement: K,
      location: this.proxyLocation,
      router: He
    });
  }
  /**
   * Record global effect and then release (effect: global event, timeout, data listener)
   * Scenes:
   * 1. unmount of default/umd app
   * 2. hidden keep-alive app
   * 3. after init prerender app
   * @param options {
   *  @param clearData clear data from base app
   *  @param isPrerender is prerender app
   *  @param keepAlive is keep-alive app
   * }
   * @param preventRecord prevent record effect events (default or destroy)
   */
  recordAndReleaseEffect(e, n = !1) {
    n ? this.resetEffectSnapshot() : this.recordEffectSnapshot(), this.releaseGlobalEffect(e);
  }
  /**
   * reset effect snapshot data in default mode or destroy
   * Scenes:
   *  1. unmount hidden keep-alive app manually
   *  2. unmount prerender app manually
   */
  resetEffectSnapshot() {
    var e, n;
    (e = this.windowEffect) === null || e === void 0 || e.reset(), (n = this.documentEffect) === null || n === void 0 || n.reset(), vt(this.microAppWindow.microApp);
  }
  /**
   * record umd snapshot before the first execution of umdHookMount
   * Scenes:
   * 1. exec umdMountHook in umd mode
   * 2. hidden keep-alive app
   * 3. after init prerender app
   */
  recordEffectSnapshot() {
    var e, n;
    (e = this.windowEffect) === null || e === void 0 || e.record(), (n = this.documentEffect) === null || n === void 0 || n.record(), wn(this.microAppWindow.microApp);
  }
  // rebuild umd snapshot before remount umd app
  rebuildEffectSnapshot() {
    var e, n;
    (e = this.windowEffect) === null || e === void 0 || e.rebuild(), (n = this.documentEffect) === null || n === void 0 || n.rebuild(), vn(this.microAppWindow.microApp);
  }
  /**
   * clear global event, timeout, data listener
   * Scenes:
   * 1. unmount of normal/umd app
   * 2. hidden keep-alive app
   * 3. after init prerender app
   * @param clearData clear data from base app
   * @param isPrerender is prerender app
   * @param keepAlive is keep-alive app
   */
  releaseGlobalEffect({ clearData: e = !1 }) {
    var n, r, o, i, s;
    (n = this.windowEffect) === null || n === void 0 || n.release(), (r = this.documentEffect) === null || r === void 0 || r.release(), (o = this.microAppWindow.microApp) === null || o === void 0 || o.clearDataListener(), (i = this.microAppWindow.microApp) === null || i === void 0 || i.clearGlobalDataListener(), e && (R.clearData(this.microAppWindow.__MICRO_APP_NAME__), (s = this.microAppWindow.microApp) === null || s === void 0 || s.clearData());
  }
  // set __MICRO_APP_PRE_RENDER__ state
  setPreRenderState(e) {
    this.microAppWindow.__MICRO_APP_PRE_RENDER__ = e;
  }
  // record umdMode
  markUmdMode(e) {
    this.microAppWindow.__MICRO_APP_UMD_MODE__ = e;
  }
  // TODO: RESTRUCTURE
  patchIframe(e, n) {
    const r = e.document;
    this.sandboxReady = new Promise((o) => {
      (function i() {
        setTimeout(() => {
          try {
            e.document === r ? i() : (e.stop(), n(o));
          } catch {
            i();
          }
        }, 0);
      })();
    });
  }
  // TODO: RESTRUCTURE
  createIframeTemplate(e) {
    const n = e.document;
    Mr(n);
    const r = n.createElement("html");
    r.innerHTML = "<head></head><body></body>", n.appendChild(r), this.microBody = n.body, this.microHead = n.head;
  }
  /**
   * baseElement will complete the relative address of element according to the URL
   * e.g: a image link script fetch ajax EventSource
   */
  createIframeBase() {
    this.baseElement = K("base"), this.updateIframeBase(), this.microHead.appendChild(this.baseElement);
  }
  /**
   * get escapeProperties from plugins & adapter
   * @param appName app name
   */
  getSpecialProperties(e) {
    var n;
    T(R.options.plugins) && (this.commonActionForSpecialProperties(R.options.plugins.global), this.commonActionForSpecialProperties((n = R.options.plugins.modules) === null || n === void 0 ? void 0 : n[e]));
  }
  // common action for global plugins and module plugins
  commonActionForSpecialProperties(e) {
    if (ee(e))
      for (const n of e)
        T(n) && ee(n.escapeProperties) && (this.escapeProperties = this.escapeProperties.concat(n.escapeProperties));
  }
  initRouteState(e) {
    Bn(this.microAppWindow.__MICRO_APP_NAME__, this.microAppWindow.location, e);
  }
  clearRouteState(e) {
    Un(this.microAppWindow.__MICRO_APP_NAME__, this.microAppWindow.__MICRO_APP_URL__, this.microAppWindow.location, e);
  }
  setRouteInfoForKeepAliveApp() {
    bt(this.microAppWindow.__MICRO_APP_NAME__, this.microAppWindow.location);
  }
  removeRouteInfoForKeepAliveApp() {
    Rt(this.microAppWindow.__MICRO_APP_NAME__);
  }
  /**
   * Format all html elements when init
   * @param container micro app container
   */
  patchStaticElement(e) {
    St(e, this.microAppWindow.__MICRO_APP_NAME__);
  }
  /**
   * action before exec scripts when mount
   * Actions:
   * 1. patch static elements from html
   * @param container micro app container
   */
  actionBeforeExecScripts(e) {
    this.patchStaticElement(e);
  }
  setStaticAppState(e) {
    this.microAppWindow.__MICRO_APP_STATE__ = e;
  }
}
Be.activeCount = 0;
const P = /* @__PURE__ */ new Map();
class Wn {
  constructor({ name: e, url: n, container: r, scopecss: o, useSandbox: i, inline: s, iframe: a, ssrUrl: c, isPrefetch: A, prefetchLevel: m, routerMode: v }) {
    this.state = U.CREATED, this.keepAliveState = null, this.loadSourceLevel = 0, this.umdHookMount = null, this.umdHookUnmount = null, this.lifeCycleState = null, this.umdMode = !1, this.sandBox = null, this.fiber = !1, P.set(e, this), this.name = e, this.url = n, this.useSandbox = i, this.scopecss = this.useSandbox && o, this.iframe = a ?? !1, this.inline = this.getInlineModeState(s), this.routerMode = v || Ie, this.container = r ?? null, this.ssrUrl = c ?? "", this.isPrefetch = A ?? !1, this.isPrerender = m === 3, this.prefetchLevel = m, this.source = { html: null, links: /* @__PURE__ */ new Set(), scripts: /* @__PURE__ */ new Set() }, this.loadSourceCode(), this.createSandbox();
  }
  // Load resources
  loadSourceCode() {
    this.setAppState(U.LOADING), mt.getInstance().run(this, ro);
  }
  /**
   * When resource is loaded, mount app if it is not prefetch or unmount
   * defaultPage disablePatchRequest routerMode baseroute is only for prerender app
   */
  onLoad({
    html: e,
    // below params is only for prerender app
    defaultPage: n,
    routerMode: r,
    baseroute: o,
    disablePatchRequest: i
  }) {
    var s;
    if (++this.loadSourceLevel === 2) {
      if (this.source.html = e, !this.isPrefetch && !this.isUnmounted())
        re(this.container).mount(this);
      else if (this.isPrerender) {
        const a = K("div");
        a.setAttribute("prerender", "true"), (s = this.sandBox) === null || s === void 0 || s.setPreRenderState(!0), this.mount({
          container: a,
          inline: this.inline,
          fiber: !0,
          defaultPage: n || "",
          disablePatchRequest: i ?? !1,
          routerMode: r,
          baseroute: o || ""
        });
      }
    }
  }
  /**
   * Error loading HTML
   * @param e Error
   */
  onLoadError(e) {
    this.loadSourceLevel = -1, this.isUnmounted() || (this.onerror(e), this.setAppState(U.LOAD_FAILED));
  }
  /**
   * mount app
   * @param container app container
   * @param inline run js in inline mode
   * @param routerMode virtual router mode
   * @param defaultPage default page of virtual router
   * @param baseroute route prefix, default is ''
   * @param disablePatchRequest prevent rewrite request method of child app
   * @param fiber run js in fiber mode
   */
  mount({ container: e, inline: n, routerMode: r, defaultPage: o, baseroute: i, disablePatchRequest: s, fiber: a }) {
    if (this.loadSourceLevel !== 2)
      return this.container = e, this.isPrerender = !1, k(this, "statechange", {
        appState: U.LOADING
      }), this.setAppState(U.LOADING);
    this.createSandbox(), this.setAppState(U.BEFORE_MOUNT);
    const c = () => {
      var A, m, v, b, M, D, g;
      if (this.isPrerender && Ar(this.container) && this.container.hasAttribute("prerender"))
        (A = this.sandBox) === null || A === void 0 || A.rebuildEffectSnapshot(), this.cloneContainer(e, this.container, !1), this.container = e, (m = this.preRenderEvents) === null || m === void 0 || m.forEach((S) => S()), this.isPrerender = !1, this.preRenderEvents = null, He.attachToURL(this.name), (v = this.sandBox) === null || v === void 0 || v.setPreRenderState(!1);
      else {
        this.container = e, this.inline = this.getInlineModeState(n), this.fiber = a, this.routerMode = r;
        const S = () => {
          this.setLifeCycleState(C.BEFOREMOUNT), oe(this.container, this.name, C.BEFOREMOUNT);
        };
        if (this.isPrerender ? ((b = this.preRenderEvents) !== null && b !== void 0 ? b : this.preRenderEvents = []).push(S) : S(), this.setAppState(U.MOUNTING), k(this, "statechange", {
          appState: U.MOUNTING
        }), this.cloneContainer(this.container, this.source.html, !this.umdMode), (M = this.sandBox) === null || M === void 0 || M.start({
          umdMode: this.umdMode,
          baseroute: i,
          defaultPage: o,
          disablePatchRequest: s
        }), !this.umdMode)
          (D = this.sandBox) === null || D === void 0 || D.actionBeforeExecScripts(this.container), Yr(this, (_) => {
            if (!this.umdMode) {
              const { mount: p, unmount: d } = this.getUmdLibraryHooks();
              if (this.umdHookUnmount = d, y(p) && y(d)) {
                this.umdHookMount = p, this.sandBox.markUmdMode(this.umdMode = !0);
                try {
                  this.handleMounted(this.umdHookMount(R.getData(this.name, !0)));
                } catch (f) {
                  O(`An error occurred in window.mount 
`, this.name, f);
                }
              } else
                _ === !0 && this.handleMounted();
            }
          });
        else {
          (g = this.sandBox) === null || g === void 0 || g.rebuildEffectSnapshot();
          try {
            this.handleMounted(this.umdHookMount(R.getData(this.name, !0)));
          } catch (_) {
            O(`An error occurred in window.mount 
`, this.name, _);
          }
        }
      }
    };
    this.sandBox ? this.sandBox.sandboxReady.then(c) : c();
  }
  /**
   * handle for promise umdHookMount
   * @param umdHookMountResult result of umdHookMount
   */
  handleMounted(e) {
    var n, r;
    const o = () => {
      ot(e) ? e.then(() => this.dispatchMountedEvent()).catch((i) => {
        O(`An error occurred in window.mount 
`, this.name, i), this.dispatchMountedEvent();
      }) : this.dispatchMountedEvent();
    };
    this.isPrerender ? ((n = this.preRenderEvents) === null || n === void 0 || n.push(o), (r = this.sandBox) === null || r === void 0 || r.recordAndReleaseEffect({ isPrerender: !0 })) : o();
  }
  /**
   * dispatch mounted event when app run finished
   */
  dispatchMountedEvent() {
    var e;
    this.isUnmounted() || (this.setAppState(U.MOUNTED), Lt(this.getMicroAppGlobalHook(me.ONMOUNT), this.name, me.ONMOUNT, R.getData(this.name, !0)), k(this, "statechange", {
      appState: U.MOUNTED
    }), k(this, "mounted"), this.setLifeCycleState(C.MOUNTED), oe(this.container, this.name, C.MOUNTED), this.isHidden() && ((e = this.sandBox) === null || e === void 0 || e.recordAndReleaseEffect({ keepAlive: !0 })));
  }
  /**
   * unmount app
   * NOTE:
   *  1. do not add any params on account of unmountApp
   * @param destroy completely destroy, delete cache resources
   * @param clearData clear data of dateCenter
   * @param keepRouteState keep route state when unmount, default is false
   * @param unmountcb callback of unmount
   */
  unmount({ destroy: e, clearData: n, keepRouteState: r, unmountcb: o }) {
    var i;
    e = e || this.state === U.LOAD_FAILED, this.setAppState(U.UNMOUNT);
    let s = null;
    try {
      s = (i = this.umdHookUnmount) === null || i === void 0 ? void 0 : i.call(this, R.getData(this.name, !0));
    } catch (a) {
      O(`An error occurred in window.unmount 
`, this.name, a);
    }
    k(this, "statechange", {
      appState: U.UNMOUNT
    }), k(this, "unmount"), Lt(this.getMicroAppGlobalHook(me.ONUNMOUNT), this.name, me.ONUNMOUNT), this.handleUnmounted({
      destroy: e,
      clearData: n,
      keepRouteState: r,
      unmountcb: o,
      umdHookUnmountResult: s
    });
  }
  /**
   * handle for promise umdHookUnmount
   * @param destroy completely destroy, delete cache resources
   * @param clearData clear data of dateCenter
   * @param keepRouteState keep route state when unmount, default is false
   * @param unmountcb callback of unmount
   * @param umdHookUnmountResult result of umdHookUnmount
   */
  handleUnmounted({ destroy: e, clearData: n, keepRouteState: r, unmountcb: o, umdHookUnmountResult: i }) {
    const s = () => this.actionsForUnmount({
      destroy: e,
      clearData: n,
      keepRouteState: r,
      unmountcb: o
    });
    ot(i) ? (B(), i.then(s).catch(s)) : s();
  }
  /**
   * actions for unmount app
   * @param destroy completely destroy, delete cache resources
   * @param clearData clear data of dateCenter
   * @param keepRouteState keep route state when unmount, default is false
   * @param unmountcb callback of unmount
   */
  actionsForUnmount({ destroy: e, clearData: n, keepRouteState: r, unmountcb: o }) {
    var i;
    this.umdMode && this.container && !e && this.cloneContainer(this.source.html, this.container, !1), (i = this.sandBox) === null || i === void 0 || i.stop({
      umdMode: this.umdMode,
      keepRouteState: r && !e,
      destroy: e,
      clearData: n || e
    }), this.setLifeCycleState(C.UNMOUNT), oe(this.container, this.name, C.UNMOUNT), this.clearOptions(e), o == null || o();
  }
  clearOptions(e) {
    this.container.innerHTML = "", this.container = null, this.isPrerender = !1, this.preRenderEvents = null, this.setKeepAliveState(null), this.iframe && !this.umdMode && (this.sandBox = null), e && this.actionsForCompletelyDestroy(), B();
  }
  // actions for completely destroy
  actionsForCompletelyDestroy() {
    var e, n;
    (n = (e = this.sandBox) === null || e === void 0 ? void 0 : e.deleteIframeElement) === null || n === void 0 || n.call(e), q.script.deleteInlineInfo(this.source.scripts), P.delete(this.name);
  }
  // hidden app when disconnectedCallback called with keep-alive
  hiddenKeepAliveApp(e) {
    var n, r;
    this.setKeepAliveState(Me.KEEP_ALIVE_HIDDEN), k(this, "appstate-change", {
      appState: "afterhidden"
    }), this.setLifeCycleState(C.AFTERHIDDEN), oe(this.container, this.name, C.AFTERHIDDEN), J(this.name) && ((n = this.sandBox) === null || n === void 0 || n.removeRouteInfoForKeepAliveApp()), this.loadSourceLevel !== 2 ? re(this.container).unmount() : (this.container = this.cloneContainer(K("div"), this.container, !1), (r = this.sandBox) === null || r === void 0 || r.recordAndReleaseEffect({ keepAlive: !0 })), e == null || e();
  }
  // show app when connectedCallback called with keep-alive
  showKeepAliveApp(e) {
    var n, r;
    (n = this.sandBox) === null || n === void 0 || n.rebuildEffectSnapshot(), k(this, "appstate-change", {
      appState: "beforeshow"
    }), oe(e, this.name, C.BEFORESHOW), this.setKeepAliveState(Me.KEEP_ALIVE_SHOW), this.container = this.cloneContainer(e, this.container, !1), J(this.name) && ((r = this.sandBox) === null || r === void 0 || r.setRouteInfoForKeepAliveApp()), k(this, "appstate-change", {
      appState: "aftershow"
    }), this.setLifeCycleState(C.AFTERSHOW), oe(this.container, this.name, C.AFTERSHOW);
  }
  /**
   * app rendering error
   * @param e Error
   */
  onerror(e) {
    this.setLifeCycleState(C.ERROR), k(this, "statechange", {
      appState: U.LOAD_FAILED
    }), oe(this.container, this.name, C.ERROR, e);
  }
  /**
   * Parse htmlString to DOM
   * NOTE: iframe sandbox will use DOMParser of iframeWindow, with sandbox will use DOMParser of base app
   * @param htmlString DOMString
   * @returns parsed DOM
   */
  parseHtmlString(e) {
    var n;
    const r = !((n = this.sandBox) === null || n === void 0) && n.proxyWindow ? this.sandBox.proxyWindow.DOMParser : l.rawWindow.DOMParser;
    return new r().parseFromString(e, "text/html").body;
  }
  /**
   * clone origin elements to target
   * @param origin Cloned element
   * @param target Accept cloned elements
   * @param deep deep clone or transfer dom
   */
  cloneContainer(e, n, r) {
    return n && (e.innerHTML = "", Array.from(r ? this.parseHtmlString(n.innerHTML).childNodes : n.childNodes).forEach((o) => {
      e.appendChild(o);
    })), e;
  }
  /**
   * Scene:
   *  1. create app
   *  2. remount of default mode with iframe sandbox
   *    In default mode with iframe sandbox, unmount app will delete iframeElement & sandBox, and create sandBox when mount again, used to solve the problem that module script cannot be execute when append it again
   */
  createSandbox() {
    this.useSandbox && !this.sandBox && (this.sandBox = this.iframe ? new Be(this.name, this.url) : new Te(this.name, this.url));
  }
  // set app state
  setAppState(e) {
    var n;
    this.state = e, (n = this.sandBox) === null || n === void 0 || n.setStaticAppState(e);
  }
  // get app state
  getAppState() {
    return this.state;
  }
  // set app lifeCycleState
  setLifeCycleState(e) {
    this.lifeCycleState = e;
  }
  // get app lifeCycleState
  getLifeCycleState() {
    return this.lifeCycleState || "";
  }
  // set keep-alive state
  setKeepAliveState(e) {
    this.keepAliveState = e;
  }
  // get keep-alive state
  getKeepAliveState() {
    return this.keepAliveState;
  }
  // is app unmounted
  isUnmounted() {
    return U.UNMOUNT === this.state;
  }
  // is app already hidden
  isHidden() {
    return Me.KEEP_ALIVE_HIDDEN === this.keepAliveState;
  }
  // get umd library, if it not exist, return empty object
  getUmdLibraryHooks() {
    if (!this.isUnmounted() && this.sandBox) {
      const e = re(this.container).getAttribute("library") || `micro-app-${this.name}`, n = this.sandBox.proxyWindow;
      return Xt(n[e]) ? n[e] : {
        mount: n.mount,
        unmount: n.unmount
      };
    }
    return {};
  }
  getMicroAppGlobalHook(e) {
    var n, r;
    const o = (r = (n = this.sandBox) === null || n === void 0 ? void 0 : n.proxyWindow) === null || r === void 0 ? void 0 : r[e];
    return y(o) ? o : null;
  }
  querySelector(e) {
    return this.container ? l.rawElementQuerySelector.call(this.container, e) : null;
  }
  querySelectorAll(e) {
    return this.container ? l.rawElementQuerySelectorAll.call(this.container, e) : [];
  }
  /**
   * NOTE:
   * 1. If the iframe sandbox no longer enforces the use of inline mode in the future, the way getElementsByTagName retrieves the script from the iframe by default needs to be changed, because in non inline mode, the script in the iframe may be empty
   * @param inline inline mode config
   */
  getInlineModeState(e) {
    var n;
    return (n = this.iframe || e) !== null && n !== void 0 ? n : !1;
  }
}
function $e(t) {
  var e, n;
  return (n = (e = P.get(t)) === null || e === void 0 ? void 0 : e.iframe) !== null && n !== void 0 ? n : !1;
}
const ne = /* @__PURE__ */ new WeakMap();
function Fn(t) {
  var e;
  return (e = ne.get(t)) !== null && e !== void 0 ? e : t;
}
function Hn(t, e) {
  if (ne.has(t))
    return ne.get(t);
  if (dt(t)) {
    if (t.hasAttribute("exclude")) {
      const n = document.createComment("style element with exclude attribute ignored by micro-app");
      return ne.set(t, n), n;
    } else if (e.scopecss && !t.hasAttribute("ignore"))
      return _t(t, e);
    return t;
  } else if (Yt(t)) {
    if (t.hasAttribute("exclude") || At(t.getAttribute("href"), e.name)) {
      const i = document.createComment("link element with exclude attribute ignored by micro-app");
      return ne.set(t, i), i;
    } else if (t.hasAttribute("ignore") || wt(t.getAttribute("href"), e.name) || t.href && y(R.options.excludeAssetFilter) && R.options.excludeAssetFilter(t.href))
      return t;
    const { address: n, linkInfo: r, replaceComment: o } = en(t, null, e, !0);
    if (n && r) {
      const i = Ur(n, e, r, t);
      return ne.set(t, i), i;
    } else if (o)
      return ne.set(t, o), o;
    return t;
  } else if (Ee(t)) {
    if (t.src && y(R.options.excludeAssetFilter) && R.options.excludeAssetFilter(t.src))
      return t;
    const { replaceComment: n, address: r, scriptInfo: o } = fn(t, null, e, !0) || {};
    if (r && o) {
      const i = o.isExternal ? zr(r, e, o, t) : Jr(r, e, o);
      return ne.set(t, i), i;
    } else if (n)
      return ne.set(t, n), n;
    return t;
  }
  return t;
}
function $n(t, e, n, r, o) {
  const i = jn(n, r, t);
  if (i) {
    if (!$e(t.name) && it(i) && e !== l.rawRemoveChild) {
      const s = Object.getOwnPropertyDescriptor(r, "parentNode");
      (!s || s.configurable) && !r.__MICRO_APP_HAS_DPN__ && ie(r, {
        parentNode: {
          configurable: !0,
          get() {
            var a, c;
            const A = l.rawParentNodeDesc.get.call(this);
            return it(A) && t.container ? ((c = (a = R.options).getRootElementParentNode) === null || c === void 0 ? void 0 : c.call(a, this, t.name)) || document.body : A;
          }
        },
        __MICRO_APP_HAS_DPN__: {
          configurable: !0,
          get: () => !0
        }
      });
    }
    if (process.env.NODE_ENV !== "production" && Er(r) && e === l.rawAppendChild && Ko(t), o && !i.contains(o)) {
      if (e === l.rawInsertBefore && n.contains(o)) {
        const s = Array.from(n.childNodes).indexOf(o);
        if (i.childNodes[s])
          return tt(e, i, r, i.childNodes[s]);
      }
      return l.rawAppendChild.call(i, r);
    } else if (e === l.rawRemoveChild && !i.contains(r))
      return n.contains(r) ? e.call(n, r) : r;
    return tt(e, i, r, o);
  }
  return tt(e, n, r, o);
}
function jn(t, e, n) {
  if (n) {
    if (t === document.head)
      return n.iframe && Ee(e) ? n.sandBox.microHead : n.querySelector("micro-app-head");
    if (t === document.body || t === document.body.parentNode)
      return n.iframe && Ee(e) ? n.sandBox.microBody : n.querySelector("micro-app-body");
    if (n.iframe && Ee(e))
      return n.sandBox.microBody;
  }
  return null;
}
function tt(t, e, n, r) {
  return ii(t) ? t.call(e, n) : t.call(e, n, r);
}
function ii(t) {
  return t === l.rawAppend || t === l.rawPrepend;
}
function si(t, e) {
  ae(e) && (/^(img|script)$/i.test(e.tagName) ? (e.hasAttribute("src") && l.rawSetAttribute.call(e, "src", G(e.getAttribute("src"), t.url)), e.hasAttribute("srcset") && l.rawSetAttribute.call(e, "srcset", G(e.getAttribute("srcset"), t.url))) : /^link$/i.test(e.tagName) && e.hasAttribute("href") && l.rawSetAttribute.call(e, "href", G(e.getAttribute("href"), t.url)));
}
function Re(t, e, n, r) {
  const o = j();
  if (ve(e) && !e.__PURE_ELEMENT__ && (e.__MICRO_APP_NAME__ || o)) {
    e.__MICRO_APP_NAME__ = e.__MICRO_APP_NAME__ || o;
    const i = P.get(e.__MICRO_APP_NAME__);
    if (dt(e) && t.getRootNode() instanceof ShadowRoot && e.setAttribute("ignore", "true"), i != null && i.container)
      return si(i, e), $n(i, r, t, Hn(e, i), n && Fn(n));
  }
  return r === l.rawAppend || r === l.rawPrepend ? r.call(t, e) : r.call(t, e, n);
}
function Gn() {
  ai();
  const t = l.rawRootElement, e = l.rawRootNode;
  t.prototype.appendChild = function(o) {
    return Re(this, o, null, l.rawAppendChild);
  }, t.prototype.insertBefore = function(o, i) {
    return Re(this, o, i, l.rawInsertBefore);
  }, t.prototype.replaceChild = function(o, i) {
    return Re(this, o, i, l.rawReplaceChild);
  }, t.prototype.append = function(...o) {
    let i = 0;
    for (; i < o.length; ) {
      let s = o[i];
      s = ve(s) ? s : l.rawCreateTextNode.call(l.rawDocument, s), Re(this, _e(s), null, l.rawAppend), i++;
    }
  }, t.prototype.prepend = function(...o) {
    let i = o.length;
    for (; i > 0; ) {
      let s = o[i - 1];
      s = ve(s) ? s : l.rawCreateTextNode.call(l.rawDocument, s), Re(this, _e(s), null, l.rawPrepend), i--;
    }
  }, t.prototype.removeChild = function(o) {
    if (o != null && o.__MICRO_APP_NAME__) {
      const i = P.get(o.__MICRO_APP_NAME__);
      if (i != null && i.container)
        return $n(i, l.rawRemoveChild, this, Fn(o));
      try {
        return l.rawRemoveChild.call(this, o);
      } catch {
        return (o == null ? void 0 : o.parentNode) && l.rawRemoveChild.call(o.parentNode, o);
      }
    }
    return l.rawRemoveChild.call(this, o);
  }, t.prototype.insertAdjacentElement = function(r, o) {
    var i;
    if (o != null && o.__MICRO_APP_NAME__ && ae(o)) {
      const s = P.get(o.__MICRO_APP_NAME__);
      if (s != null && s.container) {
        const a = Hn(o, s);
        if (!ae(a))
          return o;
        const c = (i = jn(this, a, s)) !== null && i !== void 0 ? i : this;
        return l.rawInsertAdjacentElement.call(c, r, a);
      }
    }
    return l.rawInsertAdjacentElement.call(this, r, o);
  }, t.prototype.cloneNode = function(o) {
    const i = l.rawCloneNode.call(this, o);
    return this.__MICRO_APP_NAME__ && (i.__MICRO_APP_NAME__ = this.__MICRO_APP_NAME__), i;
  };
  function n(r) {
    const o = j();
    if ((r === document.body || r === document.head) && o) {
      const i = P.get(o);
      if (i != null && i.container) {
        if (r === document.body)
          return i.querySelector("micro-app-body");
        if (r === document.head)
          return i.querySelector("micro-app-head");
      }
    }
    return r;
  }
  t.prototype.querySelector = function(o) {
    var i;
    return l.rawElementQuerySelector.call((i = n(this)) !== null && i !== void 0 ? i : this, o);
  }, t.prototype.querySelectorAll = function(o) {
    var i;
    return l.rawElementQuerySelectorAll.call((i = n(this)) !== null && i !== void 0 ? i : this, o);
  }, t.prototype.setAttribute = function(o, i) {
    const s = this.__MICRO_APP_NAME__ || j();
    if (s && P.has(s) && ((o === "src" || o === "srcset") && /^(img|script|video|audio|source|embed)$/i.test(this.tagName) || o === "href" && /^link$/i.test(this.tagName))) {
      const a = P.get(s);
      i = G(i, a.url);
    }
    l.rawSetAttribute.call(this, o, i);
  }, F(t.prototype, "innerHTML", {
    configurable: !0,
    enumerable: !0,
    get() {
      return l.rawInnerHTMLDesc.get.call(this);
    },
    set(r) {
      l.rawInnerHTMLDesc.set.call(this, r);
      const o = j();
      Array.from(this.children).forEach((i) => {
        ae(i) && o && (i.__MICRO_APP_NAME__ = o);
      });
    }
  }), F(e.prototype, "parentNode", {
    configurable: !0,
    enumerable: !0,
    get() {
      var r, o, i;
      const s = j();
      if (s && this === l.rawDocument.firstElementChild) {
        const c = (i = (o = (r = P.get(s)) === null || r === void 0 ? void 0 : r.sandBox) === null || o === void 0 ? void 0 : o.proxyWindow) === null || i === void 0 ? void 0 : i.document;
        if (c)
          return c;
      }
      return l.rawParentNodeDesc.get.call(this);
    }
  });
}
function _e(t) {
  const e = j();
  return e && (t.__MICRO_APP_NAME__ = e), t;
}
function ai() {
  const t = l.rawDocument, e = l.rawRootDocument;
  function n(i) {
    return gr(i) ? t : i;
  }
  e.prototype.createElement = function(s, a) {
    const c = l.rawCreateElement.call(n(this), s, a);
    return _e(c);
  }, e.prototype.createElementNS = function(s, a, c) {
    const A = l.rawCreateElementNS.call(n(this), s, a, c);
    return _e(A);
  }, e.prototype.createDocumentFragment = function() {
    const s = l.rawCreateDocumentFragment.call(n(this));
    return _e(s);
  }, e.prototype.createComment = function(s) {
    const a = l.rawCreateComment.call(n(this), s);
    return _e(a);
  };
  function r(i) {
    var s, a;
    const c = n(this), A = j();
    return !A || !i || Ae(i) || // ISSUE: https://github.com/micro-zoe/micro-app/issues/56
    t !== c ? l.rawQuerySelector.call(c, i) : (a = (s = P.get(A)) === null || s === void 0 ? void 0 : s.querySelector(i)) !== null && a !== void 0 ? a : null;
  }
  function o(i) {
    var s, a;
    const c = n(this), A = j();
    return !A || !i || Ae(i) || t !== c ? l.rawQuerySelectorAll.call(c, i) : (a = (s = P.get(A)) === null || s === void 0 ? void 0 : s.querySelectorAll(i)) !== null && a !== void 0 ? a : [];
  }
  e.prototype.querySelector = r, e.prototype.querySelectorAll = o, e.prototype.getElementById = function(s) {
    const a = n(this);
    if (!j() || se(s))
      return l.rawGetElementById.call(a, s);
    try {
      return r.call(a, `#${s}`);
    } catch {
      return l.rawGetElementById.call(a, s);
    }
  }, e.prototype.getElementsByClassName = function(s) {
    const a = n(this);
    if (!j() || se(s))
      return l.rawGetElementsByClassName.call(a, s);
    try {
      return o.call(a, `.${s}`);
    } catch {
      return l.rawGetElementsByClassName.call(a, s);
    }
  }, e.prototype.getElementsByTagName = function(s) {
    var a;
    const c = n(this), A = j();
    if (!A || Ae(s) || se(s) || !(!((a = P.get(A)) === null || a === void 0) && a.inline) && /^script$/i.test(s))
      return l.rawGetElementsByTagName.call(c, s);
    try {
      return o.call(c, s);
    } catch {
      return l.rawGetElementsByTagName.call(c, s);
    }
  }, e.prototype.getElementsByName = function(s) {
    const a = n(this);
    if (!j() || se(s))
      return l.rawGetElementsByName.call(a, s);
    try {
      return o.call(a, `[name=${s}]`);
    } catch {
      return l.rawGetElementsByName.call(a, s);
    }
  };
}
function ci() {
  const t = l.rawRootDocument;
  t.prototype.createElement = l.rawCreateElement, t.prototype.createElementNS = l.rawCreateElementNS, t.prototype.createDocumentFragment = l.rawCreateDocumentFragment, t.prototype.querySelector = l.rawQuerySelector, t.prototype.querySelectorAll = l.rawQuerySelectorAll, t.prototype.getElementById = l.rawGetElementById, t.prototype.getElementsByClassName = l.rawGetElementsByClassName, t.prototype.getElementsByTagName = l.rawGetElementsByTagName, t.prototype.getElementsByName = l.rawGetElementsByName;
}
function Kn() {
  B(), ci();
  const t = l.rawRootElement, e = l.rawRootNode;
  t.prototype.appendChild = l.rawAppendChild, t.prototype.insertBefore = l.rawInsertBefore, t.prototype.replaceChild = l.rawReplaceChild, t.prototype.removeChild = l.rawRemoveChild, t.prototype.append = l.rawAppend, t.prototype.prepend = l.rawPrepend, t.prototype.cloneNode = l.rawCloneNode, t.prototype.querySelector = l.rawElementQuerySelector, t.prototype.querySelectorAll = l.rawElementQuerySelectorAll, t.prototype.setAttribute = l.rawSetAttribute, F(t.prototype, "innerHTML", l.rawInnerHTMLDesc), F(e.prototype, "parentNode", l.rawParentNodeDesc);
}
let jt = !1;
function li() {
  if (!jt) {
    jt = !0;
    const t = K("style");
    l.rawSetAttribute.call(t, "type", "text/css"), t.textContent = `
${R.tagName}, micro-app-body { display: block; } 
micro-app-head { display: none; }`, l.rawDocument.head.appendChild(t);
  }
}
const l = {
  // active sandbox count
  activeSandbox: 0
};
function ui() {
  if (ut) {
    const t = window.rawWindow || Function("return window")(), e = window.rawDocument || Function("return document")(), n = t.Document || Function("return Document")(), r = t.Element, o = t.Node, i = t.EventTarget, s = r.prototype.setAttribute, a = r.prototype.appendChild, c = r.prototype.insertBefore, A = r.prototype.replaceChild, m = r.prototype.removeChild, v = r.prototype.append, b = r.prototype.prepend, M = r.prototype.cloneNode, D = r.prototype.querySelector, g = r.prototype.querySelectorAll, S = r.prototype.insertAdjacentElement, _ = Object.getOwnPropertyDescriptor(r.prototype, "innerHTML"), p = Object.getOwnPropertyDescriptor(o.prototype, "parentNode"), d = n.prototype.createElement, f = n.prototype.createElementNS, w = n.prototype.createTextNode, u = n.prototype.createDocumentFragment, h = n.prototype.createComment, E = n.prototype.querySelector, L = n.prototype.querySelectorAll, be = n.prototype.getElementById, Yn = n.prototype.getElementsByClassName, zn = n.prototype.getElementsByTagName, Jn = n.prototype.getElementsByName, Zn = new Proxy(Image, {
      construct(cr, lr) {
        const yt = new cr(...lr), Mt = j();
        return Mt && (yt.__MICRO_APP_NAME__ = Mt), yt;
      }
    }), kn = t.setInterval, er = t.setTimeout, tr = t.clearInterval, nr = t.clearTimeout, rr = t.history.pushState, or = t.history.replaceState, ir = i.prototype.addEventListener, sr = i.prototype.removeEventListener, ar = i.prototype.dispatchEvent;
    window.__MICRO_APP_BASE_APPLICATION__ = !0, z(l, {
      supportModuleScript: br(),
      // common global vars
      rawWindow: t,
      rawDocument: e,
      rawRootDocument: n,
      rawRootElement: r,
      rawRootNode: o,
      // source/patch
      rawSetAttribute: s,
      rawAppendChild: a,
      rawInsertBefore: c,
      rawReplaceChild: A,
      rawRemoveChild: m,
      rawAppend: v,
      rawPrepend: b,
      rawCloneNode: M,
      rawElementQuerySelector: D,
      rawElementQuerySelectorAll: g,
      rawInsertAdjacentElement: S,
      rawInnerHTMLDesc: _,
      rawParentNodeDesc: p,
      rawCreateElement: d,
      rawCreateElementNS: f,
      rawCreateDocumentFragment: u,
      rawCreateTextNode: w,
      rawCreateComment: h,
      rawQuerySelector: E,
      rawQuerySelectorAll: L,
      rawGetElementById: be,
      rawGetElementsByClassName: Yn,
      rawGetElementsByTagName: zn,
      rawGetElementsByName: Jn,
      ImageProxy: Zn,
      // sandbox/effect
      rawSetInterval: kn,
      rawSetTimeout: er,
      rawClearInterval: tr,
      rawClearTimeout: nr,
      rawPushState: rr,
      rawReplaceState: or,
      rawAddEventListener: ir,
      rawRemoveEventListener: sr,
      rawDispatchEvent: ar
    }), li();
  }
}
function hi(t) {
  class e extends Or() {
    constructor() {
      super(...arguments), this.isWaiting = !1, this.cacheData = null, this.connectedCount = 0, this.connectStateMap = /* @__PURE__ */ new Map(), this.appName = "", this.appUrl = "", this.ssrUrl = "", this.version = dr, this.handleAttributeUpdate = () => {
        this.isWaiting = !1;
        const r = W(this.getAttribute("name")), o = st(this.getAttribute("url"), this.appName);
        if (this.legalAttribute("name", r) && this.legalAttribute("url", o)) {
          const i = P.get(r);
          if (r !== this.appName && i && !i.isUnmounted() && !i.isHidden() && !i.isPrefetch)
            return this.setAttribute("name", this.appName), O(`app name conflict, an app named ${r} is running`);
          (r !== this.appName || o !== this.appUrl) && (r === this.appName ? this.unmount(!0, () => {
            this.actionsForAttributeChange(r, o, i);
          }) : this.getKeepAliveModeResult() ? (this.handleHiddenKeepAliveApp(), this.actionsForAttributeChange(r, o, i)) : this.unmount(!1, () => {
            this.actionsForAttributeChange(r, o, i);
          }));
        } else
          r !== this.appName && this.setAttribute("name", this.appName);
      };
    }
    static get observedAttributes() {
      return ["name", "url"];
    }
    // 👇 Configuration
    // name: app name
    // url: html address
    // shadowDom: use shadowDOM, default is false
    // destroy: whether delete cache resources when unmount, default is false
    // inline: whether js runs in inline script mode, default is false
    // disableScopecss: whether disable css scoped, default is false
    // disableSandbox: whether disable sandbox, default is false
    // baseRoute: route prefix, default is ''
    // keep-alive: open keep-alive mode
    connectedCallback() {
      const r = ++this.connectedCount;
      this.connectStateMap.set(r, !0);
      const o = this.appName && this.appUrl;
      X(() => {
        this.connectStateMap.get(r) && (oe(this, this.appName, C.CREATED), o && this.handleConnected());
      });
    }
    disconnectedCallback() {
      this.connectStateMap.set(this.connectedCount, !1), this.handleDisconnected();
    }
    /**
     * Re render app from the command line
     * MicroAppElement.reload(destroy)
     */
    reload(r) {
      return new Promise((o) => {
        const i = () => {
          this.removeEventListener(C.MOUNTED, i), this.removeEventListener(C.AFTERSHOW, i), o(!0);
        };
        this.addEventListener(C.MOUNTED, i), this.addEventListener(C.AFTERSHOW, i), this.handleDisconnected(r, () => {
          this.handleConnected();
        });
      });
    }
    /**
     * common action for unmount
     * @param destroy reload param
     */
    handleDisconnected(r = !1, o) {
      const i = P.get(this.appName);
      i && !i.isUnmounted() && !i.isHidden() && (this.getKeepAliveModeResult() && !r ? this.handleHiddenKeepAliveApp(o) : this.unmount(r, o));
    }
    attributeChangedCallback(r, o, i) {
      if (this.legalAttribute(r, i) && this[r === ye.NAME ? "appName" : "appUrl"] !== i)
        if (r === ye.URL && (!this.appUrl || !this.connectStateMap.get(this.connectedCount))) {
          if (i = st(i, this.appName), !i)
            return O(`Invalid attribute url ${i}`, this.appName);
          this.appUrl = i, this.handleInitialNameAndUrl();
        } else if (r === ye.NAME && (!this.appName || !this.connectStateMap.get(this.connectedCount))) {
          const s = W(i);
          if (!s)
            return O(`Invalid attribute name ${i}`, this.appName);
          this.cacheData && (R.setData(s, this.cacheData), this.cacheData = null), this.appName = s, s !== i && this.setAttribute("name", this.appName), this.handleInitialNameAndUrl();
        } else
          this.isWaiting || (this.isWaiting = !0, X(this.handleAttributeUpdate));
    }
    // handle for connectedCallback run before attributeChangedCallback
    handleInitialNameAndUrl() {
      this.connectStateMap.get(this.connectedCount) && this.handleConnected();
    }
    /**
     * first mount of this app
     */
    handleConnected() {
      if (!(!this.appName || !this.appUrl))
        if (this.getDisposeResult("shadowDOM") && !this.shadowRoot && y(this.attachShadow) && this.attachShadow({ mode: "open" }), this.updateSsrUrl(this.appUrl), P.has(this.appName)) {
          const r = P.get(this.appName), o = r.ssrUrl || r.url, i = this.ssrUrl || this.appUrl;
          r.isHidden() && r.url === this.appUrl ? this.handleShowKeepAliveApp(r) : o === i && (r.isUnmounted() || r.isPrefetch && this.sameCoreOptions(r)) ? this.handleMount(r) : r.isPrefetch || r.isUnmounted() ? (process.env.NODE_ENV !== "production" && this.sameCoreOptions(r) && Y(`the ${r.isPrefetch ? "prefetch" : "unmounted"} app with url: ${o} replaced by a new app with url: ${i}`, this.appName), this.handleCreateApp()) : O(`app name conflict, an app named: ${this.appName} with url: ${o} is running`);
        } else
          this.handleCreateApp();
    }
    // remount app or create app if attribute url or name change
    actionsForAttributeChange(r, o, i) {
      var s;
      this.updateSsrUrl(o), this.appName = r, this.appUrl = o, ((s = this.shadowRoot) !== null && s !== void 0 ? s : this).innerHTML = "", r !== this.getAttribute("name") && this.setAttribute("name", this.appName), i ? i.isHidden() ? i.url === this.appUrl ? this.handleShowKeepAliveApp(i) : O(`app name conflict, an app named ${this.appName} is running`) : i.url === this.appUrl && i.ssrUrl === this.ssrUrl ? this.handleMount(i) : this.handleCreateApp() : this.handleCreateApp();
    }
    /**
     * judge the attribute is legal
     * @param name attribute name
     * @param val attribute value
     */
    legalAttribute(r, o) {
      return !I(o) || !o ? (O(`unexpected attribute ${r}, please check again`, this.appName), !1) : !0;
    }
    // create app instance
    handleCreateApp() {
      const r = () => {
        var i;
        return new Wn({
          name: this.appName,
          url: this.appUrl,
          container: (i = this.shadowRoot) !== null && i !== void 0 ? i : this,
          scopecss: this.useScopecss(),
          useSandbox: this.useSandbox(),
          inline: this.getDisposeResult("inline"),
          iframe: this.getDisposeResult("iframe"),
          ssrUrl: this.ssrUrl,
          routerMode: this.getMemoryRouterMode()
        });
      }, o = P.get(this.appName);
      o ? o.isPrerender ? this.unmount(!0, r) : (o.actionsForCompletelyDestroy(), r()) : r();
    }
    /**
     * mount app
     * some serious note before mount:
     * 1. is prefetch ?
     * 2. is remount in another container ?
     * 3. is remount with change properties of the container ?
     */
    handleMount(r) {
      r.isPrefetch = !1, r.setAppState(U.BEFORE_MOUNT), X(() => this.mount(r));
    }
    /**
     * public mount action for micro_app_element & create_app
     */
    mount(r) {
      var o;
      r.mount({
        container: (o = this.shadowRoot) !== null && o !== void 0 ? o : this,
        inline: this.getDisposeResult("inline"),
        routerMode: this.getMemoryRouterMode(),
        baseroute: this.getBaseRouteCompatible(),
        defaultPage: this.getDefaultPage(),
        disablePatchRequest: this.getDisposeResult("disable-patch-request"),
        fiber: this.getDisposeResult("fiber")
      });
    }
    /**
     * unmount app
     * @param destroy delete cache resources when unmount
     * @param unmountcb callback
     */
    unmount(r, o) {
      const i = P.get(this.appName);
      i && !i.isUnmounted() && i.unmount({
        destroy: r || this.getDestroyCompatibleResult(),
        clearData: this.getDisposeResult("clear-data"),
        keepRouteState: this.getDisposeResult("keep-router-state"),
        unmountcb: o
      });
    }
    // hidden app when disconnectedCallback called with keep-alive
    handleHiddenKeepAliveApp(r) {
      const o = P.get(this.appName);
      o && !o.isUnmounted() && !o.isHidden() && o.hiddenKeepAliveApp(r);
    }
    // show app when connectedCallback called with keep-alive
    handleShowKeepAliveApp(r) {
      X(() => {
        var o;
        return r.showKeepAliveApp((o = this.shadowRoot) !== null && o !== void 0 ? o : this);
      });
    }
    /**
     * Get configuration
     * Global setting is lowest priority
     * @param name Configuration item name
     */
    getDisposeResult(r) {
      return (this.compatibleProperties(r) || !!R.options[r]) && this.compatibleDisableProperties(r);
    }
    // compatible of disableScopecss & disableSandbox
    compatibleProperties(r) {
      return r === "disable-scopecss" ? this.hasAttribute("disable-scopecss") || this.hasAttribute("disableScopecss") : r === "disable-sandbox" ? this.hasAttribute("disable-sandbox") || this.hasAttribute("disableSandbox") : this.hasAttribute(r);
    }
    // compatible of disableScopecss & disableSandbox
    compatibleDisableProperties(r) {
      return r === "disable-scopecss" ? this.getAttribute("disable-scopecss") !== "false" && this.getAttribute("disableScopecss") !== "false" : r === "disable-sandbox" ? this.getAttribute("disable-sandbox") !== "false" && this.getAttribute("disableSandbox") !== "false" : this.getAttribute(r) !== "false";
    }
    useScopecss() {
      return !(this.getDisposeResult("disable-scopecss") || this.getDisposeResult("shadowDOM"));
    }
    useSandbox() {
      return !this.getDisposeResult("disable-sandbox");
    }
    /**
     * Determine whether the core options of the existApp is consistent with the new one
     */
    sameCoreOptions(r) {
      return r.scopecss === this.useScopecss() && r.useSandbox === this.useSandbox() && r.iframe === this.getDisposeResult("iframe");
    }
    /**
     * 2021-09-08
     * get baseRoute
     * getAttribute('baseurl') is compatible writing of versions below 0.3.1
     */
    getBaseRouteCompatible() {
      var r, o;
      return (o = (r = this.getAttribute("baseroute")) !== null && r !== void 0 ? r : this.getAttribute("baseurl")) !== null && o !== void 0 ? o : "";
    }
    // compatible of destroy
    getDestroyCompatibleResult() {
      return this.getDisposeResult("destroy") || this.getDisposeResult("destory");
    }
    /**
     * destroy has priority over destroy keep-alive
     */
    getKeepAliveModeResult() {
      return this.getDisposeResult("keep-alive") && !this.getDestroyCompatibleResult();
    }
    /**
     * change ssrUrl in ssr mode
     */
    updateSsrUrl(r) {
      if (this.getDisposeResult("ssr"))
        if (this.getDisposeResult("disable-memory-router") || this.getDisposeResult("disableSandbox")) {
          const o = l.rawWindow.location;
          this.ssrUrl = G(o.pathname + o.search, r);
        } else {
          let o = go(this.appName, r);
          const i = this.getDefaultPage();
          if (!o && i) {
            const s = x(i, r);
            o = s.origin + s.pathname + s.search;
          }
          this.ssrUrl = o;
        }
      else
        this.ssrUrl && (this.ssrUrl = "");
    }
    /**
     * get config of default page
     */
    getDefaultPage() {
      return He.getDefaultPage(this.appName) || this.getAttribute("default-page") || this.getAttribute("defaultPage") || "";
    }
    /**
     * get config of router-mode
     * @returns router-mode
     */
    getMemoryRouterMode() {
      return On(
        this.getAttribute("router-mode"),
        // is micro-app element set disable-memory-router, like <micro-app disable-memory-router></micro-app>
        this.compatibleProperties("disable-memory-router") && this.compatibleDisableProperties("disable-memory-router")
      );
    }
    /**
     * rewrite micro-app.setAttribute, process attr data
     * @param key attr name
     * @param value attr value
     */
    setAttribute(r, o) {
      if (r === "data")
        if (T(o)) {
          const i = {};
          Object.getOwnPropertyNames(o).forEach((s) => {
            I(s) && s.indexOf("__") === 0 || (i[s] = o[s]);
          }), this.data = i;
        } else
          o !== "[object Object]" && Y("property data must be an object", this.appName);
      else
        l.rawSetAttribute.call(this, r, o);
    }
    /**
     * Data from the base application
     */
    set data(r) {
      this.appName ? R.setData(this.appName, r) : this.cacheData = r;
    }
    /**
     * get data only used in jsx-custom-event once
     */
    get data() {
      return this.appName ? R.getData(this.appName, !0) : this.cacheData ? this.cacheData : null;
    }
    /**
     * get publicPath from a valid address,it can used in micro-app-devtools
     */
    get publicPath() {
      return Xe(this.appUrl);
    }
    /**
     * get baseRoute from attribute,it can used in micro-app-devtools
     */
    get baseRoute() {
      return this.getBaseRouteCompatible();
    }
  }
  l.rawWindow.customElements.define(t, e);
}
function Gt(t, e) {
  if (!ut)
    return O("preFetch is only supported in browser environment");
  ze(() => {
    const n = rt(e) ? e : R.options.prefetchDelay;
    setTimeout(() => {
      di(t);
    }, rt(n) ? n : 3e3);
  });
}
function di(t) {
  y(t) && (t = t()), ee(t) && t.reduce((e, n) => e.then(() => fi(n)), Promise.resolve());
}
function fi(t) {
  return zt((e) => {
    var n, r, o, i, s, a;
    if (T(t) && navigator.onLine)
      if (t.name = W(t.name), t.url = st(t.url, t.name), t.name && t.url && !P.has(t.name)) {
        const c = new Wn({
          name: t.name,
          url: t.url,
          isPrefetch: !0,
          scopecss: !((r = (n = t["disable-scopecss"]) !== null && n !== void 0 ? n : t.disableScopecss) !== null && r !== void 0 ? r : R.options["disable-scopecss"]),
          useSandbox: !((i = (o = t["disable-sandbox"]) !== null && o !== void 0 ? o : t.disableSandbox) !== null && i !== void 0 ? i : R.options["disable-sandbox"]),
          inline: (s = t.inline) !== null && s !== void 0 ? s : R.options.inline,
          iframe: (a = t.iframe) !== null && a !== void 0 ? a : R.options.iframe,
          prefetchLevel: t.level && Tt.includes(t.level) ? t.level : R.options.prefetchLevel && Tt.includes(R.options.prefetchLevel) ? R.options.prefetchLevel : 2
        }), A = c.onLoad, m = c.onLoadError;
        c.onLoad = (v) => {
          c.isPrerender && z(v, {
            defaultPage: t["default-page"],
            /**
             * TODO: 预渲染支持disable-memory-router，默认渲染首页即可，文档中也要保留
             * 问题：
             *  1、如何确保子应用进行跳转时不影响到浏览器地址？？pure？？
             */
            routerMode: On(t["router-mode"]),
            baseroute: t.baseroute,
            disablePatchRequest: t["disable-patch-request"]
          }), e(), A.call(c, v);
        }, c.onLoadError = (...v) => {
          e(), m.call(c, ...v);
        };
      } else
        e();
    else
      e();
  });
}
function pi(t) {
  T(t) && ze(() => {
    Kt(t.js, "js", q.script), Kt(t.css, "css", q.link);
  });
}
function Kt(t, e, n) {
  if (ee(t)) {
    const r = t.filter((i) => I(i) && i.includes(`.${e}`) && !n.hasInfo(i)), o = r.map((i) => pe(i));
    Ye(o, (i) => {
      const s = r[i.index];
      e === "js" ? n.hasInfo(s) || n.setInfo(s, {
        code: i.data,
        isExternal: !1,
        appSpace: {}
      }) : n.hasInfo(s) || n.setInfo(s, {
        code: i.data,
        appSpace: {}
      });
    }, (i) => {
      O(i);
    });
  }
}
function we({ excludeHiddenApp: t = !1, excludePreRender: e = !1 } = {}) {
  const n = [];
  return P.forEach((r, o) => {
    !r.isUnmounted() && (!r.isPrefetch || r.isPrerender && !e) && (!t || !r.isHidden()) && n.push(o);
  }), n;
}
function mi() {
  return Array.from(P.keys());
}
function qn(t, e) {
  const n = P.get(W(t));
  return new Promise((r) => {
    if (n)
      if (n.isUnmounted() || n.isPrefetch)
        n.isPrerender ? n.unmount({
          destroy: !!(e != null && e.destroy),
          clearData: !!(e != null && e.clearData),
          keepRouteState: !1,
          unmountcb: r.bind(null, !0)
        }) : (e != null && e.destroy && n.actionsForCompletelyDestroy(), r(!0));
      else if (n.isHidden())
        e != null && e.destroy ? n.unmount({
          destroy: !0,
          clearData: !0,
          keepRouteState: !0,
          unmountcb: r.bind(null, !0)
        }) : e != null && e.clearAliveState ? n.unmount({
          destroy: !1,
          clearData: !!e.clearData,
          keepRouteState: !0,
          unmountcb: r.bind(null, !0)
        }) : r(!0);
      else {
        const o = re(n.container), i = () => {
          o.removeEventListener(C.UNMOUNT, i), o.removeEventListener(C.AFTERHIDDEN, s), r(!0);
        }, s = () => {
          o.removeEventListener(C.UNMOUNT, i), o.removeEventListener(C.AFTERHIDDEN, s), r(!0);
        };
        if (o.addEventListener(C.UNMOUNT, i), o.addEventListener(C.AFTERHIDDEN, s), e != null && e.destroy) {
          let a, c;
          o.hasAttribute("destroy") && (a = o.getAttribute("destroy")), o.hasAttribute("destory") && (c = o.getAttribute("destory")), o.setAttribute("destroy", "true"), o.parentNode.removeChild(o), o.removeAttribute("destroy"), I(a) && o.setAttribute("destroy", a), I(c) && o.setAttribute("destory", c);
        } else if (e != null && e.clearAliveState && o.hasAttribute("keep-alive")) {
          const a = o.getAttribute("keep-alive");
          o.removeAttribute("keep-alive");
          let c = null;
          e.clearData && (c = o.getAttribute("clear-data"), o.setAttribute("clear-data", "true")), o.parentNode.removeChild(o), o.setAttribute("keep-alive", a), I(c) && o.setAttribute("clear-data", c);
        } else {
          let a = null;
          e != null && e.clearData && (a = o.getAttribute("clear-data"), o.setAttribute("clear-data", "true")), o.parentNode.removeChild(o), I(a) && o.setAttribute("clear-data", a);
        }
      }
    else
      Y(`app ${t} does not exist`), r(!1);
  });
}
function _i(t) {
  return Array.from(P.keys()).reduce((e, n) => e.then(() => qn(n, t)), Promise.resolve(!0));
}
function Ei(t, e) {
  return new Promise((n) => {
    const r = P.get(W(t));
    if (r) {
      const o = r.container && re(r.container);
      o ? n(o.reload(e)) : (Y(`app ${t} is not rendered, cannot use reload`), n(!1));
    } else
      Y(`app ${t} does not exist`), n(!1);
  });
}
function Ai(t) {
  return new Promise((e) => {
    if (!T(t))
      return O("renderApp options must be an object");
    const n = ae(t.container) ? t.container : I(t.container) ? document.querySelector(t.container) : null;
    if (!ae(n))
      return O("Target container is not a DOM element.");
    const r = K(R.tagName);
    for (const a in t)
      if (a === "onDataChange")
        y(t[a]) && r.addEventListener("datachange", t[a]);
      else if (a === "lifeCycles") {
        const c = t[a];
        if (T(c))
          for (const A in c)
            A.toUpperCase() in C && y(c[A]) && r.addEventListener(A.toLowerCase(), c[A]);
      } else
        a !== "container" && r.setAttribute(a, t[a]);
    const o = () => {
      s(), e(!0);
    }, i = () => {
      s(), e(!1);
    }, s = () => {
      r.removeEventListener(C.MOUNTED, o), r.removeEventListener(C.ERROR, i);
    };
    r.addEventListener(C.MOUNTED, o), r.addEventListener(C.ERROR, i), n.appendChild(r);
  });
}
function wi(t) {
  const e = P.get(W(t));
  if (e)
    return e.getLifeCycleState();
  Y(`app ${t} does not exist`);
}
let vi = class extends io {
  constructor() {
    super(...arguments), this.tagName = "micro-app", this.hasInit = !1, this.options = {}, this.router = He, this.preFetch = Gt, this.unmountApp = qn, this.unmountAllApps = _i, this.getActiveApps = we, this.getAllApps = mi, this.reload = Ei, this.renderApp = Ai, this.getAppStatus = wi;
  }
  start(e) {
    var n, r;
    if (!ut || !window.customElements)
      return O("micro-app is not supported in this environment");
    if (this.hasInit)
      return O("microApp.start executed repeatedly");
    if (this.hasInit = !0, e != null && e.tagName)
      if (/^micro-app(-\S+)?/.test(e.tagName))
        this.tagName = e.tagName;
      else
        return O(`${e.tagName} is invalid tagName`);
    if (ui(), l.rawWindow.customElements.get(this.tagName))
      return Y(`element ${this.tagName} is already defined`);
    if (T(e) && (this.options = e, e["disable-scopecss"] = (n = e["disable-scopecss"]) !== null && n !== void 0 ? n : e.disableScopecss, e["disable-sandbox"] = (r = e["disable-sandbox"]) !== null && r !== void 0 ? r : e.disableSandbox, e.preFetchApps && Gt(e.preFetchApps), e.globalAssets && pi(e.globalAssets), T(e.plugins))) {
      const o = e.plugins.modules;
      if (T(o))
        for (const i in o) {
          const s = W(i);
          s && i !== s && (o[s] = o[i], delete o[i]);
        }
    }
    hi(this.tagName);
  }
};
const R = new vi();
var Qn = { exports: {} };
const qt = ur, gi = [
  "oncreated",
  "onbeforemount",
  "onmounted",
  "onunmount",
  "onerror",
  "ondatachange",
  "onbeforeshow",
  "onaftershow",
  "onafterhidden"
];
function Vn(t, e, ...n) {
  if (typeof t != "string" || !/^micro-app(-\S+)?/.test(t) || !e)
    return qt.createElement.apply(null, [t, e, ...n]);
  const r = Object.assign({}, e);
  return r.ref = (o) => {
    if (typeof e.ref == "function" ? e.ref(o) : typeof e.ref == "object" && (e.ref.current = o), o) {
      toString.call(e.data) === "[object Object]" && o.data !== e.data && (o.data = e.data);
      for (const i in e)
        if (Object.prototype.hasOwnProperty.call(e, i) && gi.includes(i.toLowerCase()) && typeof e[i] == "function" && (!o[i] || o[i] !== e[i])) {
          const s = i.toLowerCase().replace("on", "");
          o[i] && o.removeEventListener(s, o[i], !1), o.addEventListener(s, e[i], !1), o[i] = e[i];
        }
    }
  }, qt.createElement.apply(null, [t, r, ...n]);
}
Qn.exports = Vn;
Qn.exports.default = Vn;
const Pi = (t) => hr(t.tagName, t);
Pi.defaultProps = {
  tagName: "micro-app",
  style: {
    width: "100%",
    height: "100%"
  }
};
let bi = 0;
function Ri() {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(t) {
    const e = Math.random() * 16 | 0;
    return (t == "x" ? e : e & 3 | 8).toString(16);
  });
}
const Si = (t, e) => {
  var n;
  (n = window == null ? void 0 : window.microApp) == null || n.setGlobalData(t, e);
}, yi = (t) => {
  var e;
  (e = window == null ? void 0 : window.microApp) == null || e.addGlobalDataListener((n) => {
    t(n);
  });
}, Mi = () => {
  var t;
  (t = window == null ? void 0 : window.microApp) == null || t.clearGlobalData();
}, Oi = (t, e) => {
  var r;
  const n = bi++;
  (r = window == null ? void 0 : window.microApp) == null || r.setGlobalData({ [Ri()]: { ...t, index: n } }, (o) => {
    var i;
    if (e) {
      const s = (i = o == null ? void 0 : o[0]) == null ? void 0 : i.find((a) => a.index === n);
      e(s.res);
    }
  });
}, Bi = {
  setGlobalData: Si,
  addGlobalDataListener: yi,
  clearGlobalData: Mi,
  setGlobalDataQueue: Oi
}, Xn = window.__MICRO_APP_ENVIRONMENT__, Ui = window.__MICRO_APP_NAME__, Di = window.__MICRO_APP_PUBLIC_PATH__, Wi = window.__MICRO_APP_BASE_ROUTE__, Ci = window.__MICRO_APP_BASE_APPLICATION__;
function Li() {
  Xn && !Ci && (__webpack_public_path__ = Di);
}
Li();
function Fi(t) {
  Xn || document.documentElement.setAttribute("name", `${t}`);
}
export {
  An as EventCenterForMicroApp,
  Ci as MICRO_APP_BASE_APPLICATION,
  Wi as MICRO_APP_BASE_ROUTE,
  Xn as MICRO_APP_ENVIRONMENT,
  Ui as MICRO_APP_NAME,
  Di as MICRO_APP_PUBLIC_PATH,
  Pi as MicroApp,
  Fi as addNamespace,
  R as default,
  we as getActiveApps,
  mi as getAllApps,
  wi as getAppStatus,
  Gt as preFetch,
  K as pureCreateElement,
  Ei as reload,
  B as removeDomScope,
  Ai as renderApp,
  Bi as subApp,
  _i as unmountAllApps,
  qn as unmountApp,
  dr as version
};
